(function($) {
  $.fn.wysywgEditor = function(options) {
    var wyswygEl = this[0];
    if (!wyswygEl) return this;

    var configName = (options && options.config) || 'admin';
    var fileConfig = require('./configs/' + configName);
    var settings = $.extend(true, {}, fileConfig, options);
    var questionInputSel = '#' + (settings.questionInputId || 'question-intf');
    var containerSel = settings.viewerContainerSelector || '#Intf_main_container';

    var tabBySettingId = {};
    var defaultTabId = '#branding';
    settings.tabs.forEach(function(tab) {
      if (tab.default) { defaultTabId = tab.id; return; }
      (tab.settings || []).forEach(function(id) { tabBySettingId[id] = tab.id; });
    });

    $(wyswygEl).html(require('./templates/' + settings.template + '.html'));

    // State
    var $viewerHighlightedTargets = $();
    var viewerHighlightTimer = null;
    var $clickHighlightedLis = $();
    var suppressClearClickInfo = false;
    var customSettingValues = {};
    // Set while a custom-setting panel (any type) is open, to undo its live (not-yet-Applied)
    // preview change if the panel gets closed/replaced without clicking Apply. Cleared by
    // Apply itself (the change becomes the new committed state, nothing to revert to).
    var customSettingRevertFn = null;
    var sendHoverLocked = false;
    var chatOpenHoverLocked = false;
    var chatOpenHoverEl = null;
    var chatCloseHoverLocked = false;
    var chatCloseHoverEl = null;
    var copyStateLocked = false;
    var sourceButtonHoverLocked = false;
    var sourceButtonHoverEl = null;
    var chatOpenMobileNormalLocked = false;
    var chatOpenMobileHoverLocked = false;
    var chatOpenMobileContainerEl = null;
    var chatOpenMobileScaleEl = null;
    var currentBackgroundImageDataUrl = '';
    var currentBackgroundImageTransparency = 0;
    var TEXT_LIKE_TAGS = new Set(['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'P', 'SPAN', 'A', 'LABEL', 'STRONG', 'EM', 'B', 'I']);

    // gra-toolkit's own CSS always has a color + (for hover) an underline on these two states —
    // never nothing — falling back to the base icon color (project_icon_copy_button_color, same
    // '#7D888F' default as Intf_CopyButtonColor) when no state-specific custom color is set.
    function getCopyButtonBaseColor() {
      var base = (document.getElementById('project_icon_copy_button_color') || {}).value;
      return base || '#7D888F';
    }

    function applyCopyStateColor(cssProp, value) {
      var copyBtnSel = containerSel + ' .' + (settings.copyButtonClass || 'copy-button-intf');
      var color = value || getCopyButtonBaseColor();
      if (cssProp === 'style-hover-color') {
        // !important is required here: the Normal state's color is a plain inline style
        // (el.style.color), which beats any non-!important stylesheet rule regardless of the
        // :hover/.hover-preview selector's specificity — without it, hover would visually do nothing.
        setStylesData(copyBtnSel + ':hover, ' + copyBtnSel + '.hover-preview', 'color: ' + color + ' !important; text-decoration: underline;');
      } else {
        setStylesData(copyBtnSel + '.copied-button-intf', 'color: ' + color + ' !important;');
      }
    }

    // gra-toolkit's real widget always applies its own hover style on the source-button link
    // regardless of whether the admin ever sets Intf_SourceLinkButtonColorHover/TextColorHover/
    // BorderColorHover (defaults #3074FF bg / #FFFFFF text / #3074FF border, plus an underline) —
    // so, like the copy button's Hover/Copied colors, there's no "unset" state to fall back to.
    // The three properties share one :hover/.hover-preview rule on the same selector, so we keep
    // a small cache and rebuild the whole rule on every change instead of three independent
    // setStylesData() calls that would just overwrite each other.
    var SOURCE_BUTTON_HOVER_CSS_PROP_MAP = { 'source-hover-bg': 'background-color', 'source-hover-text': 'color', 'source-hover-border': 'border-color' };
    var SOURCE_BUTTON_HOVER_DEFAULTS = { 'background-color': '#3074FF', 'color': '#FFFFFF', 'border-color': '#3074FF' };
    var sourceButtonHoverStyleValues = { 'background-color': '#3074FF', 'color': '#FFFFFF', 'border-color': '#3074FF' };

    function applySourceButtonHoverStyle(realProp, value) {
      sourceButtonHoverStyleValues[realProp] = value || SOURCE_BUTTON_HOVER_DEFAULTS[realProp];
      var linkSel = containerSel + ' .url-text-link-intf';
      var styles = Object.keys(sourceButtonHoverStyleValues).map(function(prop) {
        return prop + ': ' + sourceButtonHoverStyleValues[prop] + ' !important;';
      }).join(' ') + ' text-decoration: underline;';
      setStylesData(linkSel + ':hover, ' + linkSel + '.hover-preview', styles);
    }

    function setViewerSettings(item, first) {
      if (!item || item.length === 0) return;
      var id = item.attr('id');
      if (!id) return;
      var cssProp = settings.viewerIdStyles[id];
      if (!cssProp) return;

      if (id === 'project_icon_light_mode_color' && !first) toggleDarkLightMode('light');
      if (id === 'project_icon_dark_mode_color' && !first) toggleDarkLightMode('dark');
      if (id === 'project_icon_scroll_down_color' && !first) { scrollToTop(); scrollToBottom(); }
      if (id === 'project_question_text_color' && !first) $(questionInputSel).val('Test question input text');
      if (settings.scrollPositions[id] !== undefined && !first) scrollViewerTo(settings.scrollPositions[id]);

      var value = item.val();
      if (id === 'project_icons_chat_close_border_color') updateChatBorderViewBox(value);
      if (id === 'project_text_icon_length') updateTextIconLength(value);
      if (id === 'project_text_icon_mobile_length') applyMobileTextIconLength(value);
      if (id === 'project_header_color') {
        var headerDisclaimerEl = document.getElementById('header-disclaimer-intf');
        if (headerDisclaimerEl) headerDisclaimerEl.style.backgroundColor = value;
      }
      if (id === 'project_terms_conditions_link_color') {
        document.querySelectorAll('[data-viewer~="project_terms_conditions_link_color"] a').forEach(function(a) { a.style.color = value; });
      }
      if (id === 'project_close_open_icons_scale') {
        var hintWrapperEl = document.getElementById('hint-wrapper-intf');
        if (hintWrapperEl) hintWrapperEl.style.height = (65 * (parseFloat(value) || 100) / 100) + 'px';
        updateIconBlockStacking();
      }
      if (cssProp === 'font-setting') { updateViewerFonts(); return; }

      var guardSet = settings.guardById[id];

      if (!value) {
        if (cssProp === 'style-hover-color' || cssProp === 'style-copied-color') {
          // gra-toolkit never leaves this bare — no custom color set just means "fall back to
          // the base icon color", not "no styling at all" (hover always keeps its underline too).
          applyCopyStateColor(cssProp, null);
          return;
        }
        if (SOURCE_BUTTON_HOVER_CSS_PROP_MAP[cssProp]) {
          applySourceButtonHoverStyle(SOURCE_BUTTON_HOVER_CSS_PROP_MAP[cssProp], null);
          return;
        }
        if (settings.fallbackById[id]) {
          document.querySelectorAll('[data-viewer~="' + id + '"]').forEach(function(el) { el.removeAttribute('data-viewer-priority'); });
          var fallbackInput = $('#' + settings.fallbackById[id]);
          if (fallbackInput.length && fallbackInput.val()) { setViewerSettings(fallbackInput); return; }
        }
        var resetPxProps = {
          'width-px':              function(el) { el.style.width = ''; },
          'width-percent':         function(el) { el.style.width = ''; },
          'border-radius-px':      function(el) { el.style.borderRadius = '15px'; },
          'padding-tb-px':         function(el) { el.style.paddingTop = '5px'; el.style.paddingBottom = '5px'; },
          'padding-lr-px':         function(el) { el.style.paddingLeft = '10px'; el.style.paddingRight = '10px'; },
          'height-px':             function(el) { el.style.height = ''; },
          'input-height-percent':  function(el) {
            el.style.paddingTop = ''; el.style.paddingBottom = '';
          },
          'border-width-px':       function(el) { el.style.borderWidth = ''; el.style.borderStyle = ''; },
          'font-size-px':          function(el) { el.style.fontSize = ''; },
          'font-weight':           function(el) { el.style.fontWeight = ''; },
          'dot-size-px':           function(el) { var ds = el.querySelectorAll('.dot-intf,.dot-text-intf'); (ds.length ? ds : [el]).forEach(function(d) { d.style.width = ''; d.style.height = ''; }); },
          'dot-margin-px':         function(el) { var ds = el.querySelectorAll('.dot-intf,.dot-text-intf'); (ds.length ? ds : [el]).forEach(function(d) { d.style.marginLeft = ''; }); },
          'typing-jump-height-px': function(el) { var s = document.getElementById('gra-typing-style'); if (s) s.textContent = ''; },
          'padding-all-px':        function(el) { el.style.padding = ''; },
          'border-radius-br-px':   function(el) { el.style.borderBottomRightRadius = ''; },
          'border-radius-bl-px':   function(el) { el.style.borderBottomLeftRadius = ''; },
          'border-radius-block-px': function(el) {
            el.style.borderTopLeftRadius = '0px'; el.style.borderTopRightRadius = '0px';
            el.style.borderBottomLeftRadius = '0px'; el.style.borderBottomRightRadius = '0px';
            (el.getAttribute('data-viewer') || '').trim().split(/\s+/).forEach(function(otherId) {
              var otherProp = settings.viewerIdStyles[otherId];
              if (otherProp !== 'border-radius-br-px' && otherProp !== 'border-radius-bl-px') return;
              var otherEl = document.getElementById(otherId); var otherVal = otherEl ? otherEl.value : null;
              if (!otherVal) return;
              if (otherProp === 'border-radius-br-px') el.style.borderBottomRightRadius = otherVal + 'px';
              else el.style.borderBottomLeftRadius = otherVal + 'px';
            });
          },
          'transform-scale':            function(el) { el.style.transform = ''; },
          'transform-scale-translatey': function(el) { el.style.removeProperty('transform'); },
          'zoom-scale':                 function(el) { el.style.removeProperty('zoom'); },
          'background-color':     function(el) { el.style.removeProperty('background-color'); },
          'color':                function(el) { el.style.removeProperty('color'); },
          'border-color':         function(el) { el.style.removeProperty('border-color'); },
          'fill':                 function(el) { el.removeAttribute('fill'); },
          'stroke':               function(el) { el.removeAttribute('stroke'); },
          'stop-color':           function(el) { el.removeAttribute('stop-color'); },
          'dot-bg-color':         function(el) {
            var ds = el.querySelectorAll('.dot-intf,.dot-text-intf'); (ds.length ? ds : [el]).forEach(function(d) { d.style.removeProperty('background-color'); });
          },
          'style-placeholder-color': function() { setStylesData(questionInputSel + '::placeholder', 'color: unset !important'); },
          // Per-element target (fill/stroke/color/...) read from data-viewer-details, used where
          // the same setting recolors different attributes on different elements (e.g. the copy
          // button's text vs its SVG icons).
          'details': function(el) {
            var detailAttr = el.getAttribute('data-viewer-details');
            if (!detailAttr) return;
            if (detailAttr === 'fill' || detailAttr === 'stroke' || detailAttr === 'stop-color') el.removeAttribute(detailAttr);
            else el.style.removeProperty(detailAttr);
          },
        };
        if (resetPxProps[cssProp]) {
          document.querySelectorAll('[data-viewer~="' + id + '"]').forEach(function(el) {
            if (guardSet) {
              var current = el.getAttribute('data-viewer-priority');
              if (guardSet.has(current)) return;
            }
            resetPxProps[cssProp](el);
          });
        }
        return;
      }

      var viewerEls = document.querySelectorAll('[data-viewer~="' + id + '"]');
      if (!viewerEls) return;

      var priorityToSet = settings.priorityById[id];

      viewerEls.forEach(function(el) {
        if (guardSet) {
          var current = el.getAttribute('data-viewer-priority');
          if (guardSet.has(current)) return;
        }
        if (priorityToSet) el.setAttribute('data-viewer-priority', priorityToSet);

        var cssPropDetails = null;
        if (cssProp === 'details') cssPropDetails = el.getAttribute('data-viewer-details');

        if (cssProp === 'stroke' || cssProp === 'fill' || cssProp === 'stop-color' || cssPropDetails === 'stroke' || cssPropDetails === 'fill') {
          el.setAttribute(cssPropDetails ? cssPropDetails : cssProp, value);
        } else if (cssProp === 'style-hover-color' || cssProp === 'style-copied-color') {
          applyCopyStateColor(cssProp, value);
        } else if (SOURCE_BUTTON_HOVER_CSS_PROP_MAP[cssProp]) {
          applySourceButtonHoverStyle(SOURCE_BUTTON_HOVER_CSS_PROP_MAP[cssProp], value);
        } else if (cssProp === 'style-placeholder-color' || cssPropDetails === 'style-placeholder-color') {
          setStylesData(questionInputSel + '::placeholder', 'color: ' + value + ' !important');
        } else if (cssProp === 'width-px' || cssPropDetails === 'width-px') {
          el.style.width = value + 'px';
        } else if (cssProp === 'width-percent') {
          el.style.width = value + '%';
        } else if (cssProp === 'border-radius-px') {
          el.style.borderRadius = value + 'px';
        } else if (cssProp === 'border-radius-block-px') {
          el.style.borderTopLeftRadius = value + 'px'; el.style.borderTopRightRadius = value + 'px';
          el.style.borderBottomLeftRadius = value + 'px'; el.style.borderBottomRightRadius = value + 'px';
          (el.getAttribute('data-viewer') || '').trim().split(/\s+/).forEach(function(otherId) {
            if (otherId === id) return;
            var otherProp = settings.viewerIdStyles[otherId];
            if (otherProp !== 'border-radius-br-px' && otherProp !== 'border-radius-bl-px') return;
            var otherEl = document.getElementById(otherId); var otherVal = otherEl ? otherEl.value : null;
            if (!otherVal) return;
            if (otherProp === 'border-radius-br-px') el.style.borderBottomRightRadius = otherVal + 'px';
            else el.style.borderBottomLeftRadius = otherVal + 'px';
          });
        } else if (cssProp === 'padding-tb-px') {
          el.style.paddingTop = value + 'px'; el.style.paddingBottom = value + 'px';
        } else if (cssProp === 'padding-lr-px') {
          el.style.paddingLeft = value + 'px'; el.style.paddingRight = value + 'px';
        } else if (cssProp === 'height-px') {
          el.style.height = value + 'px';
        } else if (cssProp === 'border-width-px') {
          el.style.borderWidth = value + 'px';
          el.style.borderStyle = 'solid';
        } else if (cssProp === 'font-size-px') {
          el.style.fontSize = value + 'px';
        } else if (cssProp === 'padding-all-px') {
          el.style.padding = value + 'px';
        } else if (cssProp === 'border-radius-br-px') {
          el.style.borderBottomRightRadius = value + 'px';
        } else if (cssProp === 'border-radius-bl-px') {
          el.style.borderBottomLeftRadius = value + 'px';
        } else if (cssProp === 'transform-scale') {
          el.style.transform = 'scale(' + value / 100 + ')';
        } else if (cssProp === 'transform-scale-translatey') {
          el.style.setProperty('transform', 'translateY(-50%) scale(' + value / 100 + ')', 'important');
        } else if (cssProp === 'zoom-scale') {
          el.style.zoom = value / 100;
        } else if (cssProp === 'dot-bg-color') {
          var dotBgEls = el.querySelectorAll('.dot-intf,.dot-text-intf');
          (dotBgEls.length ? dotBgEls : [el]).forEach(function(d) { d.style.backgroundColor = value; });
        } else if (cssProp === 'dot-size-px') {
          var dotSizeEls = el.querySelectorAll('.dot-intf,.dot-text-intf');
          (dotSizeEls.length ? dotSizeEls : [el]).forEach(function(d) { d.style.width = value + 'px'; d.style.height = value + 'px'; });
        } else if (cssProp === 'dot-margin-px') {
          var dotMarginEls = el.querySelectorAll('.dot-intf,.dot-text-intf');
          (dotMarginEls.length ? dotMarginEls : [el]).forEach(function(d) { d.style.marginLeft = value + 'px'; });
        } else if (cssProp === 'typing-jump-height-px') {
          var jumpPx = '-' + parseInt(value) + 'px';
          var jumpStyleEl = document.getElementById('gra-typing-style');
          if (!jumpStyleEl) { jumpStyleEl = document.createElement('style'); jumpStyleEl.id = 'gra-typing-style'; document.head.appendChild(jumpStyleEl); }
          jumpStyleEl.textContent = '@keyframes graJumpingAnimation{0%{transform:translate(0,0)}16%{transform:translate(0,' + jumpPx + ')}33%{transform:translate(0,0)}100%{transform:translate(0,0)}}';
        } else if (cssProp === 'input-height-percent') {
          var padding = 10 * value / 100;
          el.style.paddingTop = padding + 'px';
          el.style.paddingBottom = padding + 'px';
        } else {
          el.style[cssPropDetails ? cssPropDetails : cssProp] = value;
        }
      });
    }

    function toggleDarkLightMode(mode) {
      var container = document.getElementById('id-dark-light-container-intf');
      if (!container) return;
      var darkSvg = container.querySelector('.icon-dark-mode-intf');
      var lightSvg = container.querySelector('.icon-light-mode-intf');
      if (!darkSvg || !lightSvg) return;
      var isLightShown = !lightSvg.classList.contains('hidden-intf');
      if (mode === 'dark') { if (!isLightShown) return; darkSvg.classList.remove('hidden-intf'); lightSvg.classList.add('hidden-intf'); return; }
      if (mode === 'light') { if (isLightShown) return; lightSvg.classList.remove('hidden-intf'); darkSvg.classList.add('hidden-intf'); return; }
      darkSvg.classList.toggle('hidden-intf');
      lightSvg.classList.toggle('hidden-intf');
    }

    function setStylesData(selector, styles) {
      var styleEl = document.getElementById('wyswyg-style');
      if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.id = 'wyswyg-style';
        document.head.appendChild(styleEl);
      }
      var sheet = styleEl.sheet;
      var ruleText = selector + ' { ' + styles + ' }';
      var existingIndex = Array.from(sheet.cssRules).findIndex(function(rule) { return rule.selectorText === selector; });
      if (existingIndex !== -1) sheet.deleteRule(existingIndex);
      sheet.insertRule(ruleText, sheet.cssRules.length);
    }

    function scrollViewerTo(top) {
      var rc = document.getElementById('response-container-intf');
      if (rc) rc.scrollTo({ top: top, behavior: 'smooth' });
    }

    function scrollToBottom() {
      var rc = document.getElementById('response-container-intf');
      if (!rc) return;
      rc.scrollTo({ top: rc.scrollHeight, behavior: 'smooth' });
      var upBtn = document.getElementById('icon-scroll-up-intf');
      var downBtn = document.getElementById('icon-scroll-down-intf');
      if (upBtn) upBtn.classList.remove('hidden-intf');
      if (downBtn) downBtn.classList.add('hidden-intf');
    }

    function scrollToTop() {
      var rc = document.getElementById('response-container-intf');
      if (!rc) return;
      rc.scrollTo({ top: 0, behavior: 'smooth' });
      var upBtn = document.getElementById('icon-scroll-up-intf');
      var downBtn = document.getElementById('icon-scroll-down-intf');
      if (downBtn) downBtn.classList.remove('hidden-intf');
      if (upBtn) upBtn.classList.add('hidden-intf');
    }

    function resetDarkLightMode() {
      var darkSvg = document.getElementById('icon-dark-mode-intf');
      var lightSvg = document.getElementById('icon-light-mode-intf');
      if (darkSvg) darkSvg.classList.add('hidden-intf');
      if (lightSvg) lightSvg.classList.remove('hidden-intf');
    }

    function updateViewerFonts() {
      var isDefaultContainer = (containerSel === '#Intf_main_container');
      var mainUrl      = (document.getElementById('project_main_font_url')   || {}).value || '';
      var titleUrl     = (document.getElementById('project_title_font_url')  || {}).value || '';
      var fontScale    = (document.getElementById('project_font_scale')      || {}).value || '';
      var hintFontSize = (document.getElementById('project_hint_font_size')  || {}).value || '';
      var defaultBaseInputFontSize = parseFloat(wyswygEl.dataset.defaultBaseFontSizeInputField) || 16;
      var defaultBaseTypingFontSize = parseFloat(wyswygEl.dataset.defaultBaseFontSizeTypingText) || 14;
      var baseInputFontSize = parseFloat((document.getElementById('project_base_font_size_input_field') || {}).value) || defaultBaseInputFontSize;
      var baseTypingFontSize = parseFloat((document.getElementById('project_base_font_size_typing_text') || {}).value) || defaultBaseTypingFontSize;
      var defaultBaseTitleFontSize = parseFloat(wyswygEl.dataset.defaultBaseFontSizeTitle) || 16;
      var defaultBaseSubtitleFontSize = parseFloat(wyswygEl.dataset.defaultBaseFontSizeSubtitle) || 16;
      var baseTitleFontSize = parseFloat((document.getElementById('project_base_font_size_title') || {}).value) || defaultBaseTitleFontSize;
      var baseSubtitleFontSize = parseFloat((document.getElementById('project_base_font_size_subtitle') || {}).value) || defaultBaseSubtitleFontSize;
      var css = '';
      // Always declare the Roboto @font-face, regardless of which font branch below is
      // active, so the popup override further down can use it unconditionally.
      css += "@font-face { font-family: 'Roboto'; src: url('https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu7GxKOzY.woff2'); font-weight: 100 900; }\n";
      if (mainUrl.trim()) {
        css += '@font-face { font-family: "IntfMainFont"; src: url("' + mainUrl.trim().replace(/"/g, '%22') + '"); font-weight: 100 900; }\n';
        css += containerSel + ', ' + containerSel + ' *, ' + questionInputSel + ' { font-family: "IntfMainFont", sans-serif !important; }\n';
      } else {
        css += containerSel + ', ' + containerSel + ' *, ' + questionInputSel + " { font-family: 'Roboto', sans-serif !important; }\n";
      }
      // WYSIWYG popups (click-info, custom-setting panel, warning message) are appended
      // inside this same container, so the rule above also catches them — force them back
      // to the widget's own default font regardless of the Main font URL setting.
      css += '#wyswyg-click-info, #wyswyg-click-info *, '
        + '#wyswyg-custom-panel, #wyswyg-custom-panel *, '
        + '#wyswyg-message, #wyswyg-message * '
        + "{ font-family: 'Roboto', sans-serif !important; }\n";
      if (titleUrl.trim()) {
        css += '@font-face { font-family: "IntfTitleFont"; src: url("' + titleUrl.trim().replace(/"/g, '%22') + '"); font-weight: 100 900; }\n';
        if (isDefaultContainer) {
          css += '#Intf_main_container .question-title-person-intf, #Intf_main_container .answer-title-person-intf { font-family: "IntfTitleFont", sans-serif !important; }\n';
        } else {
          css += containerSel + ' [class*="title-person-intf"] { font-family: "IntfTitleFont", sans-serif !important; }\n';
        }
      } else {
        css += "@font-face { font-family: 'Montserrat'; src: url('https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtr6Hw5aXo.woff2'); font-weight: 100 900; }\n";
        if (isDefaultContainer) {
          css += "#Intf_main_container .question-title-person-intf, #Intf_main_container .answer-title-person-intf { font-family: 'Montserrat', sans-serif !important; }\n";
        } else {
          css += containerSel + " [class*=\"title-person-intf\"] { font-family: 'Montserrat', sans-serif !important; }\n";
        }
      }
      if (fontScale.trim() && fontScale.trim() !== '100') {
        var scale = parseFloat(fontScale) / 100;
        if (isDefaultContainer) {
          css += '#Intf_main_container .message-container-intf, #Intf_main_container .message-container-intf * { font-size: calc(16px * ' + scale + ') !important; }\n';
          css += '#Intf_main_container .message-container-intf .header-disclaimer-intf * { font-size: calc(12px * ' + scale + ') !important; }\n';
          css += '#Intf_main_container #terms-conditions-id-intf, #Intf_main_container #terms-conditions-id-intf a { font-size: calc(12px * ' + scale + ') !important; }\n';
          css += '#Intf_main_container .message-container-intf .hello-block-title-intf { font-size: calc(24px * ' + scale + ') !important; }\n';
          css += '#Intf_main_container .message-container-intf .hello-block-text-intf { font-size: calc(18px * ' + scale + ') !important; }\n';
          css += '#question-intf { font-size: calc(' + baseInputFontSize + 'px * ' + scale + ') !important; }\n';
          css += '#Intf_main_container .hint-text-intf { font-size: calc(16px * ' + scale + ') !important; }\n';
        } else {
          css += containerSel + ', ' + containerSel + ' * { font-size: calc(16px * ' + scale + ') !important; }\n';
          css += questionInputSel + ' { font-size: calc(' + baseInputFontSize + 'px * ' + scale + ') !important; }\n';
          css += containerSel + ' .typing-label-intf_gra, ' + containerSel + ' .typing-label-intf_gra * { font-size: calc(' + baseTypingFontSize + 'px * ' + scale + ') !important; }\n';
          css += containerSel + ' .answer-title-person-intf_gra, ' + containerSel + ' .question-title-person-intf_gra { font-size: calc(' + baseTitleFontSize + 'px * ' + scale + ') !important; }\n';
          css += containerSel + ' .answer-title-name-intf_gra, ' + containerSel + ' .question-title-name-intf_gra { font-size: calc(' + baseSubtitleFontSize + 'px * ' + scale + ') !important; }\n';
          // Header/footer disclaimer text is hardcoded to 12px in the stylesheet (GRA only)
          // and must stay fixed regardless of font_scale — not scaled at all.
          css += containerSel + ' .header_disclaimer_gra *, ' + containerSel + ' .footer_disclaimer_gra * { font-size: 12px !important; }\n';
          // WYSIWYG popups (click-info, custom-setting panel, warning message) are appended
          // inside this same container, so the broad rule above also catches them — re-assert
          // their own fixed sizes (from active_admin.scss) with ID-scoped selectors so they
          // win on specificity without needing :not() exclusions (which inflate specificity
          // via ID count and would drown out the field-specific rules above).
          css += '#wyswyg-message { font-size: 12px !important; }\n';
          css += '#wyswyg-message .wyswyg-message-title { font-size: 12px !important; font-weight: 500 !important; }\n';
          css += '#wyswyg-message .wyswyg-message-text, #wyswyg-message-text { font-size: 10px !important; }\n';
          css += '#wyswyg-click-info { font-size: 12px !important; }\n';
          css += '#wyswyg-click-info .wyswyg-click-info-title { font-size: 11px !important; font-weight: 600 !important; }\n';
          css += '#wyswyg-click-info .wyswyg-click-info-item { font-size: 11px !important; }\n';
          css += '#wyswyg-click-info .wyswyg-click-info-close { font-size: 14px !important; }\n';
          css += '#wyswyg-custom-panel { font-size: 12px !important; }\n';
          css += '#wyswyg-custom-panel .wyswyg-custom-panel-title { font-size: 11px !important; font-weight: 600 !important; }\n';
          css += '#wyswyg-custom-panel .wyswyg-custom-panel-desc { font-size: 10px !important; }\n';
          css += '#wyswyg-custom-panel .wyswyg-custom-apply-btn { font-size: 11px !important; }\n';
        }
      }
      if (hintFontSize.trim() && isDefaultContainer) {
        css += '#Intf_main_container .hint-text-intf { font-size: ' + hintFontSize.trim() + 'px !important; }\n';
      }
      var styleEl = wyswygEl.querySelector('#viewer-fonts-intf');
      if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.id = 'viewer-fonts-intf';
        document.head.appendChild(styleEl);
      }
      styleEl.textContent = css;
    }

    function updateChatBorderViewBox(color) {
      var isActive = color && color !== '0' && color !== 'false';
      document.querySelectorAll('[data-viewer~="project_icons_chat_close_border_color"]').forEach(function(el) {
        var svg = el.tagName.toLowerCase() === 'svg' ? el : el.closest('svg');
        if (!svg) return;
        var vb = svg.getAttribute('viewBox');
        var parts = vb.split(' ');
        var vbW = parseInt(parts[2]);
        var vbH = parseInt(parts[3]);
        var hasBorderNow = vb.startsWith('-');
        var isDefaultIcon = (vbW === vbH || Math.abs(vbW - vbH) <= 4);
        if (isActive) {
          if (!hasBorderNow) {
            svg.setAttribute('viewBox', '-2 -2 ' + (vbW + 4) + ' ' + (vbH + 4));
            if (isDefaultIcon) { el.setAttribute('stroke-width', '4'); el.setAttribute('paint-order', 'stroke fill'); }
          }
        } else {
          if (hasBorderNow) {
            svg.setAttribute('viewBox', '0 0 ' + (vbW - 4) + ' ' + (vbH - 4));
            if (isDefaultIcon) { el.removeAttribute('stroke-width'); el.removeAttribute('paint-order'); }
          }
          el.setAttribute('stroke', 'none');
        }
      });
    }

    function resizeTextIconSvg(svg, L) {
      var midPath = svg.querySelector('[data-text-icon-mid]');
      if (!midPath) return;
      var vb = svg.getAttribute('viewBox');
      var hasBorder = vb && vb.startsWith('-');
      svg.setAttribute('viewBox', hasBorder ? ('-2 -2 ' + (L + 69) + ' 69') : ('0 0 ' + (L + 65) + ' 65'));
      midPath.setAttribute('d', 'M 18 0 H ' + (L + 46) + ' V 64 H 18 Z');
      var rightPath = svg.querySelector('[data-text-icon-right]');
      if (rightPath) rightPath.setAttribute('transform', 'translate(' + L + ' 0)');
      var borderPath = svg.querySelector('[data-viewer~="project_icons_chat_close_border_color"]');
      if (borderPath) borderPath.setAttribute('d', 'M 20 0 H ' + (L + 46) + ' A 18 18 0 0 1 ' + (L + 64) + ' 18 V 58 a 6 6 0 0 1 -6 6 H 20 A 18 18 0 0 1 2 46 V 18 A 18 18 0 0 1 20 0 Z');
    }

    function updateIconBlockStacking() {
      var scale = parseFloat($('#project_close_open_icons_scale').val()) || 100;
      var lengthVal = $('#project_text_icon_length').val();
      var L = (lengthVal && lengthVal !== '0') ? (parseInt(lengthVal) || 90) : 90;
      var openIsCustom = $('#icon-chat-open-custom-intf').is(':visible');
      var closeIsCustom = $('#icon-chat-close-custom-intf').is(':visible');
      var openHasText = !openIsCustom && !!(($('#project_text_icon_text').val() || '').trim());
      var closeHasText = !closeIsCustom && !!(($('#project_text_icon_close_text').val() || '').trim());
      var openWidth = (openHasText ? (L + 65) : 65) * (scale / 100);
      var closeWidth = (closeHasText ? (L + 65) : 65) * (scale / 100);
      var iconBlock = document.querySelector('.icon-block-intf');
      if (iconBlock) iconBlock.classList.toggle('stacked-intf', Math.max(openWidth, closeWidth) > 200);
    }

    function updateTextIconLength(value) {
      var L = (value && value !== '0') ? (parseInt(value) || 90) : 90;
      ['#icon-chat-open-text-intf', '#icon-chat-close-text-intf'].forEach(function(wrapperId) {
        var wrapper = document.querySelector(wrapperId);
        if (!wrapper) return;
        wrapper.querySelectorAll('svg.icon-intf').forEach(function(svg) { resizeTextIconSvg(svg, L); });
      });
      updateIconBlockStacking();
    }

    function applyMobileTextIconLength(value) {
      var L = (value && value !== '0') ? (parseInt(value) || 90) : 90;
      document.querySelectorAll('#icon-chat-open-text-intf svg.mobile-preview').forEach(function(svg) { resizeTextIconSvg(svg, L); });
    }

    function applyViewerHighlight(inputId) {
      clearTimeout(viewerHighlightTimer);
      viewerHighlightTimer = null;
      clearViewerWarnings();
      $viewerHighlightedTargets.removeClass('viewer-highlight');
      $viewerHighlightedTargets = $();
      if (!inputId) return;
      checkInputWarning(inputId);
      var prop = inputId.replace(/^project_/, '');
      var targets = [];

      $('[data-viewer~="' + inputId + '"]', wyswygEl).each(function() {
        var target = this.ownerSVGElement ? this.closest('svg') : this;
        if (target && targets.indexOf(target) === -1) targets.push(target);
      });
      $('[data-text-viewer~="' + prop + '"]', wyswygEl).each(function() {
        if (targets.indexOf(this) === -1) targets.push(this);
      });
      $('[data-text-viewer-single~="' + prop + '"]', wyswygEl).each(function() {
        if (targets.indexOf(this) === -1) targets.push(this);
      });
      if (inputId === 'project_icon_answer_text_color' || inputId === 'project_icon_answer_background_color_from' || inputId === 'project_icon_answer_background_color_to') {
        var customIcon = document.getElementById('answer-icon-custom');
        if (customIcon && customIcon.style.display !== 'none' && targets.indexOf(customIcon) === -1) targets.push(customIcon);
      }

      $viewerHighlightedTargets = $(targets);
      $viewerHighlightedTargets.addClass('viewer-highlight');

      if (inputId === 'project_icon_dark_mode_color') {
        var dm = document.getElementById('icon-dark-mode-intf');
        var lm = document.getElementById('icon-light-mode-intf');
        if (dm) dm.classList.remove('hidden-intf');
        if (lm) lm.classList.add('hidden-intf');
      } else {
        resetDarkLightMode();
      }

      if (inputId === 'project_icon_scroll_down_color') {
        scrollToTop();
      } else if (settings.scrollPositions.hasOwnProperty(inputId)) {
        scrollViewerTo(settings.scrollPositions[inputId]);
      }

      var hoverSendIds = ['project_icon_send_hover_scale', 'project_icon_send_hover'];
      if (hoverSendIds.indexOf(inputId) !== -1 && !sendHoverLocked) {
        var sendBtnEl = document.getElementById('id-btn-send-question-intf');
        if (sendBtnEl) sendBtnEl.classList.add('hover-preview');
      }

      if (inputId === 'project_question_text_color') {
        $(questionInputSel).val('Test question input text');
      } else if (inputId === 'project_question_placeholder_color') {
        $(questionInputSel).val('');
      }
    }

    function removeViewerHighlight() {
      $viewerHighlightedTargets.removeClass('viewer-highlight');
      $viewerHighlightedTargets = $();
      resetDarkLightMode();
      if (!sendHoverLocked) {
        var sendBtnEl = document.getElementById('id-btn-send-question-intf');
        if (sendBtnEl) sendBtnEl.classList.remove('hover-preview');
      }
    }

    function clearViewerWarnings() {
      var warningMessage = wyswygEl.querySelector('#wyswyg-message');
      if (warningMessage) warningMessage.style.display = 'none';
      wyswygEl.querySelectorAll('.wyswyg-warning-setting').forEach(function(el) { el.classList.remove('wyswyg-warning-setting'); });
    }

    function revertPendingCustomSettingPreview() {
      if (!customSettingRevertFn) return;
      customSettingRevertFn();
      customSettingRevertFn = null;
    }

    function clearClickInfo() {
      if (sendHoverLocked) {
        sendHoverLocked = false;
        var sendBtnEl = document.getElementById('id-btn-send-question-intf');
        if (sendBtnEl) sendBtnEl.classList.remove('hover-preview');
      }
      if (chatOpenHoverLocked) {
        chatOpenHoverLocked = false;
        if (chatOpenHoverEl) { chatOpenHoverEl.classList.remove('hover-preview'); chatOpenHoverEl = null; }
      }
      if (chatCloseHoverLocked) {
        chatCloseHoverLocked = false;
        if (chatCloseHoverEl) { chatCloseHoverEl.classList.remove('hover-preview'); chatCloseHoverEl = null; }
      }
      if (copyStateLocked) {
        copyStateLocked = false;
        resetCopyState();
      }
      if (sourceButtonHoverLocked) {
        sourceButtonHoverLocked = false;
        if (sourceButtonHoverEl) { sourceButtonHoverEl.classList.remove('hover-preview'); sourceButtonHoverEl = null; }
      }
      if (chatOpenMobileNormalLocked || chatOpenMobileHoverLocked) {
        chatOpenMobileNormalLocked = false;
        chatOpenMobileHoverLocked = false;
        if (chatOpenMobileContainerEl) {
          chatOpenMobileContainerEl.classList.remove('mobile-normal-active', 'mobile-hover-active');
          chatOpenMobileContainerEl = null;
        }
        if (chatOpenMobileScaleEl) {
          chatOpenMobileScaleEl.classList.remove('mobile-preview');
          chatOpenMobileScaleEl.removeAttribute('data-custom-viewer');
          chatOpenMobileScaleEl = null;
          setViewerSettings($('#project_close_open_icons_scale'));
        }
      }
      resetDarkLightMode();
      clearViewerWarnings();
      $clickHighlightedLis.removeClass('viewer-click-highlight');
      $clickHighlightedLis = $();
      wyswygEl.querySelectorAll('.viewer-highlight').forEach(function(el) { el.classList.remove('viewer-highlight'); });
      var popup = wyswygEl.querySelector('#wyswyg-click-info');
      if (popup) popup.style.display = 'none';
      var customPanel = wyswygEl.querySelector('#wyswyg-custom-panel');
      if (customPanel) {
        revertPendingCustomSettingPreview();
        var panelInput = customPanel.querySelector('input.minicolors-input');
        if (panelInput) { try { $(panelInput).minicolors('destroy'); } catch(ex) {} }
        if (customPanel.parentNode) customPanel.parentNode.removeChild(customPanel);
      }
    }

    function findPreciseTarget(target, clientX, clientY) {
      var el = target.closest('[data-viewer]');
      while (el) {
        if (TEXT_LIKE_TAGS.has(el.tagName)) {
          var rect = el.getBoundingClientRect();
          var style = window.getComputedStyle(el);
          var innerLeft   = rect.left   + (parseFloat(style.paddingLeft)   || 0);
          var innerRight  = rect.right  - (parseFloat(style.paddingRight)  || 0);
          var innerTop    = rect.top    + (parseFloat(style.paddingTop)    || 0);
          var innerBottom = rect.bottom - (parseFloat(style.paddingBottom) || 0);
          if (clientX >= innerLeft && clientX <= innerRight && clientY >= innerTop && clientY <= innerBottom) return el;
          el = el.parentElement ? el.parentElement.closest('[data-viewer]') : null;
        } else {
          return el;
        }
      }
      return null;
    }

    function showClickInfo(el) {
      clearClickInfo();
      var settingIds = [];
      function addIds(attr) {
        if (!attr) return;
        attr.trim().split(/\s+/).forEach(function(id) { if (id && settingIds.indexOf(id) === -1) settingIds.push(id); });
      }
      var svgRoot = (el.tagName && el.tagName.toLowerCase() === 'svg') ? el : (el.closest ? el.closest('svg') : null);
      if (svgRoot) {
        addIds(svgRoot.getAttribute('data-viewer'));
        svgRoot.querySelectorAll('[data-viewer]').forEach(function(child) { addIds(child.getAttribute('data-viewer')); });
      } else {
        addIds(el.getAttribute('data-viewer'));
      }
      if (el.classList && el.classList.contains('hint-text-intf') && el.getBoundingClientRect().height > 39) {
        var hintWrapperEl = el.closest('.hint-wrapper-intf');
        if (hintWrapperEl) addIds(hintWrapperEl.getAttribute('data-viewer'));
      }
      var tvEl = el.closest ? el.closest('[data-text-viewer]') : null;
      if (tvEl) {
        addIds((tvEl.getAttribute('data-text-viewer') || '').trim().split(/\s+/).filter(Boolean).map(function(p) { return 'project_' + p; }).join(' '));
      }
      var singleTv = el.getAttribute ? el.getAttribute('data-text-viewer-single') : null;
      if (singleTv) addIds(singleTv.trim().split(/\s+/).filter(Boolean).map(function(p) { return 'project_' + p; }).join(' '));
      var customSettingIds = [];
      var cvEl = el.closest ? el.closest('[data-custom-viewer]') : null;
      if (cvEl) {
        (cvEl.getAttribute('data-custom-viewer') || '').trim().split(/\s+/).filter(Boolean).forEach(function(id) {
          if (settings.customSettings[id]) customSettingIds.push(id);
        });
      }
      var singleCv = el.getAttribute ? el.getAttribute('data-custom-viewer-single') : null;
      if (singleCv) {
        singleCv.trim().split(/\s+/).filter(Boolean).forEach(function(id) {
          if (settings.customSettings[id]) customSettingIds.push(id);
        });
      }
      if (!settingIds.length && !customSettingIds.length) return;

      var items = [];
      var liEls = [];
      settingIds.forEach(function(id) {
        var li = document.getElementById(id + '_input');
        var label = li ? li.querySelector('.label') : null;
        if (li && label) { items.push({ id: id, label: label.innerText.trim() }); liEls.push(li); }
      });
      customSettingIds.forEach(function(id) {
        var link = document.querySelector('.color-custom-setting-link[data-custom-setting-id="' + id + '"]');
        if (link) liEls.push(link);
      });
      if (!items.length && !customSettingIds.length) return;

      $clickHighlightedLis = $(liEls);
      $clickHighlightedLis.addClass('viewer-click-highlight');
      liEls.forEach(function(highlightedEl) {
        var group = highlightedEl.closest('.color-group');
        if (group) group.classList.remove('collapsed');
      });

      var darkSvgEl = document.getElementById('icon-dark-mode-intf');
      var lightSvgEl = document.getElementById('icon-light-mode-intf');
      if (el === darkSvgEl) {
        if (darkSvgEl) darkSvgEl.classList.remove('hidden-intf');
        if (lightSvgEl) lightSvgEl.classList.add('hidden-intf');
      } else if (el === lightSvgEl) {
        if (lightSvgEl) lightSvgEl.classList.remove('hidden-intf');
        if (darkSvgEl) darkSvgEl.classList.add('hidden-intf');
      }

      el.classList.add('viewer-highlight');
      var scrollUp = document.getElementById('icon-scroll-up-intf');
      var scrollDown = document.getElementById('icon-scroll-down-intf');
      if (el === scrollUp || el === scrollDown) {
        if (scrollUp) scrollUp.classList.add('viewer-highlight');
        if (scrollDown) scrollDown.classList.add('viewer-highlight');
      }

      var popup = wyswygEl.querySelector('#wyswyg-click-info');
      if (!popup) {
        popup = document.createElement('div');
        popup.id = 'wyswyg-click-info';
        popup.classList.add('wyswyg-click-info');
        var mainCont = wyswygEl.querySelector('#Intf_main_container') || wyswygEl.querySelector('#anim_container_intf') || wyswygEl;
        mainCont.appendChild(popup);
      }
      popup.innerHTML = '<button class="wyswyg-click-info-close">✕</button>' +
        '<div class="wyswyg-click-info-title">Settings:</div>' +
        items.map(function(item) {
          return '<div class="wyswyg-click-info-item" data-setting-id="' + item.id + '">' + item.label + '</div>';
        }).join('') +
        (customSettingIds.length ?
          '<hr class="wyswyg-custom-separator">' +
          customSettingIds.map(function(id) {
            return '<div class="wyswyg-click-info-item wyswyg-custom-item" data-custom-id="' + id + '">' + customSettingLabel(id) + '</div>';
          }).join('') : '');
      popup.style.display = 'block';

      popup.querySelector('.wyswyg-click-info-close').addEventListener('click', function(e) { e.stopPropagation(); clearClickInfo(); });
      popup.querySelectorAll('.wyswyg-click-info-item:not(.wyswyg-custom-item)').forEach(function(itemEl) {
        itemEl.addEventListener('click', function(e) {
          e.stopPropagation();
          var li = document.getElementById(itemEl.dataset.settingId + '_input');
          if (li) {
            var switched = switchToTabForSetting(itemEl.dataset.settingId);
            setTimeout(function() {
              li.scrollIntoView({ behavior: 'smooth', block: 'center' });
              var input = li.querySelector('input.minicolors-input, input[type="text"], select, input[type="radio"]');
              if (input) setTimeout(function() { input.focus(); }, 300);
            }, switched ? 300 : 0);
          }
        });
      });
      popup.querySelectorAll('.wyswyg-custom-item').forEach(function(itemEl) {
        itemEl.addEventListener('click', function(e) { e.stopPropagation(); openCustomSettingPanel(itemEl.dataset.customId); });
      });
      makeDraggable(popup);
    }

    function makeDraggable(popup, handleSelector) {
      var titleEl = popup.querySelector(handleSelector || '.wyswyg-click-info-title');
      if (!titleEl) return;
      titleEl.addEventListener('mousedown', function(e) {
        if (e.button !== 0) return;
        e.preventDefault();
        e.stopPropagation();
        var cont = popup.parentElement;
        var contRect = cont.getBoundingClientRect();
        var popupRect = popup.getBoundingClientRect();
        var offsetX = e.clientX - popupRect.left;
        var offsetY = e.clientY - popupRect.top;
        popup.style.right = '';
        popup.style.left = (popupRect.left - contRect.left) + 'px';
        popup.style.top  = (popupRect.top  - contRect.top)  + 'px';
        function onMove(ev) {
          var r = cont.getBoundingClientRect();
          var x = Math.max(0, Math.min(ev.clientX - r.left - offsetX, cont.offsetWidth  - popup.offsetWidth));
          var y = Math.max(0, Math.min(ev.clientY - r.top  - offsetY, cont.offsetHeight - popup.offsetHeight));
          popup.style.left = x + 'px';
          popup.style.top  = y + 'px';
        }
        function onUp() {
          document.removeEventListener('mousemove', onMove);
          document.removeEventListener('mouseup', onUp);
        }
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
      });
    }

    function customSettingLabel(id) {
      var setting = settings.customSettings[id];
      if (setting && setting.label) return setting.label;
      return id.replace(/^Intf_/, '').replace(/([A-Z])/g, ' $1').trim()
        .toLowerCase().replace(/^./, function(c) { return c.toUpperCase(); });
    }

    function highlightCustomCodeField() {
      var li = document.getElementById('project_custom_js_input');
      if (!li) return;
      li.scrollIntoView({ behavior: 'smooth', block: 'center' });
      $clickHighlightedLis = $clickHighlightedLis.add(li);
      li.classList.add('viewer-click-highlight');
      var container = li.querySelector('.ace-editor-container');
      if (container) { try { ace.edit(container).focus(); } catch(ex) {} }
    }

    // These two multiline text settings are rendered as HTML (not SVG <text> lines) by the actual
    // widget, so their line breaks are stored as <br> instead of an escaped \n.
    var NEWLINE_AS_BR_SETTING_IDS = ['Intf_IconChatHoverFullText', 'Intf_IconChatMobileHoverFullText'];

    function applyCustomSettingToCustomCode(settingId, value) {
      var container = document.querySelector('#project_custom_js_input .ace-editor-container');
      if (!container) return;
      var editor = ace.edit(container);
      var current = editor.session.getValue();
      var isNumeric = settings.customSettings[settingId] && settings.customSettings[settingId].type === 'number';
      var useBrNewlines = NEWLINE_AS_BR_SETTING_IDS.indexOf(settingId) !== -1;
      var regex = new RegExp('global\\.' + settingId + '\\s*=\\s*(?:[\'"][^\'"]*[\'"]|-?\\d+(?:\\.\\d+)?)\\s*;[ \\t]*\\n?');
      if (value) {
        var escapedValue = isNumeric ? value : String(value).replace(/\r\n|\r|\n/g, useBrNewlines ? '<br>' : '\\n');
        var newLine = 'global.' + settingId + ' = ' + (isNumeric ? escapedValue : '\'' + escapedValue + '\'') + ';\n';
        if (regex.test(current)) {
          editor.session.setValue(current.replace(regex, newLine));
        } else {
          var trimmed = current.trimEnd();
          editor.session.setValue(trimmed + (trimmed ? '\n' : '') + newLine);
        }
      } else {
        editor.session.setValue(current.replace(regex, '').trimEnd());
      }
    }

    function openCustomSettingPanel(settingId) {
      var setting = settings.customSettings[settingId];
      if (!setting) return;
      var mainCont = wyswygEl.querySelector('#Intf_main_container') || wyswygEl.querySelector('#anim_container_intf') || wyswygEl;

      var oldPanel = wyswygEl.querySelector('#wyswyg-custom-panel');
      if (oldPanel) {
        revertPendingCustomSettingPreview();
        var oldInput = oldPanel.querySelector('input.minicolors-input');
        if (oldInput) { try { $(oldInput).minicolors('destroy'); } catch(ex) {} }
        oldPanel.parentNode.removeChild(oldPanel);
      }

      var panel = document.createElement('div');
      panel.id = 'wyswyg-custom-panel';
      panel.className = 'wyswyg-custom-panel';
      panel.addEventListener('click', function(e) { e.stopPropagation(); });
      mainCont.appendChild(panel);

      var infoPopup = wyswygEl.querySelector('#wyswyg-click-info');
      if (infoPopup) infoPopup.style.display = 'none';

      var currentValue = customSettingValues[settingId] || '';

      function closePanel() {
        revertPendingCustomSettingPreview();
        var inp = panel.querySelector('input.minicolors-input');
        if (inp) { try { $(inp).minicolors('destroy'); } catch(ex) {} }
        if (panel.parentNode) panel.parentNode.removeChild(panel);
      }

      if (setting.type === 'text') {
        // Most text settings are single-line; opt into multiline on the setting definition for
        // the rare one that maps to several stacked <text> lines in an icon (max 3, since that's
        // as many lines as the text-icon layout positions).
        var maxLines = setting.multiline ? (setting.maxLines || 3) : 0;
        var fieldHtml = maxLines
          ? '<textarea rows="' + maxLines + '" class="wyswyg-custom-text-input wyswyg-custom-textarea-input" placeholder="Enter text...">' + currentValue.replace(/</g, '&lt;') + '</textarea>'
          : '<input type="text" class="wyswyg-custom-text-input" placeholder="Enter text..." value="' + currentValue.replace(/"/g, '&quot;') + '">';
        panel.innerHTML =
          '<button class="wyswyg-click-info-close wyswyg-custom-panel-close">✕</button>' +
          '<div class="wyswyg-custom-panel-title">' + customSettingLabel(settingId) + '</div>' +
          '<div class="wyswyg-custom-panel-desc">' + setting.description + '</div>' +
          fieldHtml +
          '<button class="wyswyg-custom-apply-btn">Apply</button>';

        var textInput = panel.querySelector('.wyswyg-custom-text-input');
        textInput.addEventListener('input', function() {
          if (maxLines) {
            var lines = this.value.split('\n');
            if (lines.length > maxLines) this.value = lines.slice(0, maxLines).join('\n');
          }
          if (this.value) { customSettingValues[settingId] = this.value; } else { delete customSettingValues[settingId]; }
          if (setting.onChange) setting.onChange(this.value);
        });
        if (currentValue && setting.onChange) setting.onChange(currentValue);

        customSettingRevertFn = function() {
          if (currentValue) { customSettingValues[settingId] = currentValue; } else { delete customSettingValues[settingId]; }
          if (setting.onChange) setting.onChange(currentValue);
        };

        panel.querySelector('.wyswyg-custom-panel-close').addEventListener('click', function(e) { e.stopPropagation(); closePanel(); });
        panel.querySelector('.wyswyg-custom-apply-btn').addEventListener('click', function(e) {
          e.stopPropagation();
          customSettingRevertFn = null;
          var value = textInput.value;
          if (value) { customSettingValues[settingId] = value; } else { delete customSettingValues[settingId]; }
          switchToTabForSetting(settingId);
          applyCustomSettingToCustomCode(settingId, value);
          highlightCustomCodeField();
          closePanel();
        });
        makeDraggable(panel, '.wyswyg-custom-panel-title');
        return;
      }

      if (setting.type === 'number') {
        // Most number settings are integers (character counts, px, z-index); opt into
        // step: 'any' on the setting definition for the rare one that needs decimals
        // (e.g. Intf_iconSizeScaleMobile, a 0-1 ratio) without affecting the rest.
        var numberStep = setting.step || '1';
        var toInt = function(raw) {
          var n = numberStep === 'any' ? parseFloat(raw) : parseInt(raw, 10);
          return isNaN(n) ? null : n;
        };
        var displayValue = currentValue !== '' ? currentValue : (setting.default !== undefined && setting.default !== null ? setting.default : '');

        panel.innerHTML =
          '<button class="wyswyg-click-info-close wyswyg-custom-panel-close">✕</button>' +
          '<div class="wyswyg-custom-panel-title">' + customSettingLabel(settingId) + '</div>' +
          '<div class="wyswyg-custom-panel-desc">' + setting.description + '</div>' +
          '<input type="number" step="' + numberStep + '" class="wyswyg-custom-text-input" value="' + displayValue + '">' +
          '<button class="wyswyg-custom-apply-btn">Apply</button>';

        var numberInput = panel.querySelector('.wyswyg-custom-text-input');
        numberInput.addEventListener('input', function() {
          var n = toInt(this.value);
          if (n !== null) { customSettingValues[settingId] = String(n); } else { delete customSettingValues[settingId]; }
          if (setting.onChange) setting.onChange(n !== null ? n : setting.default);
        });
        if (setting.onChange) setting.onChange(toInt(displayValue) !== null ? toInt(displayValue) : setting.default);

        customSettingRevertFn = function() {
          if (currentValue) { customSettingValues[settingId] = currentValue; } else { delete customSettingValues[settingId]; }
          if (setting.onChange) setting.onChange(toInt(displayValue) !== null ? toInt(displayValue) : setting.default);
        };

        panel.querySelector('.wyswyg-custom-panel-close').addEventListener('click', function(e) { e.stopPropagation(); closePanel(); });
        panel.querySelector('.wyswyg-custom-apply-btn').addEventListener('click', function(e) {
          e.stopPropagation();
          customSettingRevertFn = null;
          var n = toInt(numberInput.value);
          var value = n !== null ? String(n) : '';
          if (value) { customSettingValues[settingId] = value; } else { delete customSettingValues[settingId]; }
          switchToTabForSetting(settingId);
          applyCustomSettingToCustomCode(settingId, value);
          highlightCustomCodeField();
          closePanel();
        });
        makeDraggable(panel, '.wyswyg-custom-panel-title');
        return;
      }

      if (setting.type === 'boolean') {
        var boolDisplay = (currentValue === 'true' || currentValue === 'false') ? currentValue : String(!!setting.default);
        var radioName = 'wyswyg-custom-bool-' + settingId;

        panel.innerHTML =
          '<button class="wyswyg-click-info-close wyswyg-custom-panel-close">✕</button>' +
          '<div class="wyswyg-custom-panel-title">' + customSettingLabel(settingId) + '</div>' +
          '<div class="wyswyg-custom-panel-desc">' + setting.description + '</div>' +
          '<div class="wyswyg-custom-bool-input">' +
            '<label><input type="radio" name="' + radioName + '" value="true"' + (boolDisplay === 'true' ? ' checked' : '') + '> True</label>' +
            '<label><input type="radio" name="' + radioName + '" value="false"' + (boolDisplay === 'false' ? ' checked' : '') + '> False</label>' +
          '</div>' +
          '<button class="wyswyg-custom-apply-btn">Apply</button>';

        var boolRadios = panel.querySelectorAll('input[name="' + radioName + '"]');
        boolRadios.forEach(function(radio) {
          radio.addEventListener('change', function() {
            if (!this.checked) return;
            customSettingValues[settingId] = this.value;
            if (setting.onChange) setting.onChange(this.value);
          });
        });
        if (setting.onChange) setting.onChange(boolDisplay);

        customSettingRevertFn = function() {
          if (currentValue) { customSettingValues[settingId] = currentValue; } else { delete customSettingValues[settingId]; }
          if (setting.onChange) setting.onChange(boolDisplay);
        };

        panel.querySelector('.wyswyg-custom-panel-close').addEventListener('click', function(e) { e.stopPropagation(); closePanel(); });
        panel.querySelector('.wyswyg-custom-apply-btn').addEventListener('click', function(e) {
          e.stopPropagation();
          customSettingRevertFn = null;
          var checked = panel.querySelector('input[name="' + radioName + '"]:checked');
          var value = checked ? checked.value : boolDisplay;
          customSettingValues[settingId] = value;
          switchToTabForSetting(settingId);
          applyCustomSettingToCustomCode(settingId, value);
          highlightCustomCodeField();
          closePanel();
        });
        makeDraggable(panel, '.wyswyg-custom-panel-title');
        return;
      }

      var displayColorValue = currentValue || setting.default || '';

      panel.innerHTML =
        '<button class="wyswyg-click-info-close wyswyg-custom-panel-close">✕</button>' +
        '<div class="wyswyg-custom-panel-title">' + customSettingLabel(settingId) + '</div>' +
        '<div class="wyswyg-custom-panel-desc">' + setting.description + '</div>' +
        '<button class="wyswyg-custom-apply-btn">Apply</button>' +
        '<input type="text" id="' + settingId + '" class="minicolors-input wyswyg-custom-color-input"' + (displayColorValue ? ' value="' + displayColorValue + '"' : '') + '>';

      var colorInput = panel.querySelector('.wyswyg-custom-color-input');
      var colorPreviewDirty = false;
      $(colorInput).minicolors({ format: 'hex', change: function() { colorPreviewDirty = true; setViewerSettings($(colorInput)); } });
      if (displayColorValue) setViewerSettings($(colorInput), true);

      // Any pick made in this picker before Apply is just a live preview — if the panel closes
      // without Apply (✕, clicking elsewhere, or opening another setting's panel), this puts the
      // preview back to what was actually committed (currentValue) or, failing that, the default.
      customSettingRevertFn = function() {
        if (!colorPreviewDirty) return;
        colorInput.value = displayColorValue;
        setViewerSettings($(colorInput), true);
      };

      panel.querySelector('.wyswyg-custom-panel-close').addEventListener('click', function(e) { e.stopPropagation(); closePanel(); });
      panel.querySelector('.wyswyg-custom-apply-btn').addEventListener('click', function(e) {
        e.stopPropagation();
        customSettingRevertFn = null;
        var value = $(colorInput).minicolors('value');
        if (value) { customSettingValues[settingId] = value; } else { delete customSettingValues[settingId]; }
        switchToTabForSetting(settingId);
        applyCustomSettingToCustomCode(settingId, value);
        highlightCustomCodeField();
        closePanel();
      });
      makeDraggable(panel, '.wyswyg-custom-panel-title');
    }

    function closeStatePicker() {
      var picker = document.getElementById('wyswyg-send-state-picker');
      if (picker) picker.style.display = 'none';
    }

    function showStatePicker(anchorEl, onSelect, opts) {
      clearClickInfo();
      var picker = document.getElementById('wyswyg-send-state-picker');
      if (!picker) {
        picker = document.createElement('div');
        picker.id = 'wyswyg-send-state-picker';
        picker.className = 'wyswyg-send-state-picker';
        document.body.appendChild(picker);
        picker.addEventListener('click', function(e) { e.stopPropagation(); });
      }
      var pickerOptions = opts || [{label: 'Normal', state: 'normal'}, {label: 'Hover', state: 'hover'}];
      picker.innerHTML =
        '<button class="wyswyg-click-info-close">✕</button>' +
        '<div class="wyswyg-click-info-title">View state:</div>' +
        pickerOptions.map(function(o) { return '<div class="wyswyg-send-state-option" data-state="' + o.state + '">' + o.label + '</div>'; }).join('');
      picker.style.display = 'block';
      picker.style.visibility = 'hidden';
      var rect = anchorEl.getBoundingClientRect();
      var pickerH = picker.offsetHeight;
      var pickerW = picker.offsetWidth;
      var top = rect.top - pickerH - 6;
      var left = rect.left + rect.width / 2 - pickerW / 2;
      if (left < 4) left = 4;
      if (left + pickerW > window.innerWidth - 4) left = window.innerWidth - pickerW - 4;
      picker.style.top = top + 'px';
      picker.style.left = left + 'px';
      picker.style.visibility = '';
      picker.querySelector('.wyswyg-click-info-close').addEventListener('click', function(e) { e.stopPropagation(); closeStatePicker(); });
      picker.querySelectorAll('.wyswyg-send-state-option').forEach(function(optEl) {
        optEl.addEventListener('click', function(e) { e.stopPropagation(); closeStatePicker(); onSelect(optEl.dataset.state); });
      });
    }

    function showSendStatePicker(btn) {
      showStatePicker(btn, function(state) {
        var sendBtnEl = document.getElementById('id-btn-send-question-intf');
        if (state === 'hover') {
          var hoverSvg = sendBtnEl.querySelector('.icon-send-intf.hidden-intf')
                      || wyswygEl.querySelector('#icon-send-hover-custom-gra:not(.hidden-intf)')
                      || wyswygEl.querySelector('#icon-send-hover-default-gra');
          if (hoverSvg) showClickInfo(hoverSvg);
          sendHoverLocked = true; sendBtnEl.classList.add('hover-preview');
        } else {
          var normalSvg = sendBtnEl.querySelector('.icon-send-intf:not(.hidden-intf)')
                       || wyswygEl.querySelector('#icon-send-custom-gra:not(.hidden-intf)')
                       || wyswygEl.querySelector('#icon-send-default-gra');
          if (normalSvg) showClickInfo(normalSvg);
        }
      });
    }

    // Only the "open" (closed-widget/start-chat) icon gets a Mobile state — the "close" icon
    // isn't shown at all in the mobile version, so there's nothing to preview there.
    var CHAT_OPEN_ICON_STATE_OPTIONS = [{label: 'Normal', state: 'normal'}, {label: 'Hover', state: 'hover'}, {label: 'Mobile Normal', state: 'mobile'}, {label: 'Mobile Hover', state: 'mobile-hover'}];

    function showChatOpenStatePicker(containerEl) {
      showStatePicker(containerEl, function(state) {
        var isTextIcon = containerEl.id === 'icon-chat-open-text-intf';
        if (state === 'hover') {
          var hoverSvg = containerEl.querySelector('.icon-intf.hidden-intf');
          if (hoverSvg && isTextIcon && customSettingValues['Intf_IconChatHoverTextFontSize']) {
            hoverSvg.querySelectorAll('text').forEach(function(t) { t.style.fontSize = customSettingValues['Intf_IconChatHoverTextFontSize'] + 'px'; });
          }
          if (hoverSvg) showClickInfo(hoverSvg);
          chatOpenHoverLocked = true; chatOpenHoverEl = containerEl; containerEl.classList.add('hover-preview');
        } else if ((state === 'mobile' || state === 'mobile-hover') && isTextIcon) {
          // Mobile Normal/Hover are dedicated, always-present icons for the text-icon variant (built in
          // rebuildTextIcons), so previewing them is just showing/hiding, same as the Hover branch above.
          var targetClass = state === 'mobile' ? 'mobile-normal-intf' : 'mobile-hover-intf';
          var activeClass = state === 'mobile' ? 'mobile-normal-active' : 'mobile-hover-active';
          var dedicatedSvg = containerEl.querySelector('.icon-intf.' + targetClass);
          if (dedicatedSvg) {
            containerEl.classList.add(activeClass);
            chatOpenMobileContainerEl = containerEl;
            showClickInfo(dedicatedSvg);
            if (state === 'mobile') { chatOpenMobileNormalLocked = true; } else { chatOpenMobileHoverLocked = true; }
          }
        } else if (state === 'mobile' || state === 'mobile-hover') {
          // Default icon / custom-uploaded icon: no dedicated hover variant, just scale the normal icon.
          var scaleSvg = containerEl.querySelector('.icon-intf:not(.hidden-intf)');
          if (scaleSvg) {
            scaleSvg.classList.add('mobile-preview');
            scaleSvg.setAttribute('data-custom-viewer', 'Intf_iconSizeScaleMobile');
            scaleSvg.style.transform = 'scale(' + (customSettingValues['Intf_iconSizeScaleMobile'] || 0.6923) + ')';
            showClickInfo(scaleSvg);
            chatOpenMobileScaleEl = scaleSvg;
            chatOpenMobileNormalLocked = true;
          }
        } else {
          var normalSvg = containerEl.querySelector('.icon-intf:not(.hidden-intf)');
          if (normalSvg) showClickInfo(normalSvg);
        }
      }, CHAT_OPEN_ICON_STATE_OPTIONS);
    }

    function showChatCloseStatePicker(containerEl) {
      showStatePicker(containerEl, function(state) {
        if (state === 'hover') {
          var hoverSvg = containerEl.querySelector('.icon-intf.hidden-intf');
          if (hoverSvg && containerEl.id === 'icon-chat-close-text-intf' && customSettingValues['Intf_IconCloseHoverTextFontSize']) {
            hoverSvg.querySelectorAll('text').forEach(function(t) { t.style.fontSize = customSettingValues['Intf_IconCloseHoverTextFontSize'] + 'px'; });
          }
          if (hoverSvg) showClickInfo(hoverSvg);
          chatCloseHoverLocked = true; chatCloseHoverEl = containerEl; containerEl.classList.add('hover-preview');
        } else {
          var normalSvg = containerEl.querySelector('.icon-intf:not(.hidden-intf)');
          if (normalSvg) showClickInfo(normalSvg);
        }
      });
    }

    function showDarkLightStatePicker(containerEl) {
      showStatePicker(containerEl, function(state) {
        var darkSvg = document.getElementById('icon-dark-mode-intf');
        var lightSvg = document.getElementById('icon-light-mode-intf');
        if (state === 'dark') { if (darkSvg) showClickInfo(darkSvg); }
        else { if (lightSvg) showClickInfo(lightSvg); }
      }, [{label: 'Light mode', state: 'light'}, {label: 'Dark mode', state: 'dark'}]);
    }

    function showSourceButtonStatePicker(el) {
      var linkEl = el.closest('.url-text-link-intf') || el;
      showStatePicker(linkEl, function(state) {
        if (state === 'hover') {
          var hoverEl = linkEl.parentElement && linkEl.parentElement.querySelector('.source-button-hover-settings-intf');
          if (hoverEl) showClickInfo(hoverEl);
          sourceButtonHoverLocked = true; sourceButtonHoverEl = linkEl; linkEl.classList.add('hover-preview');
          linkEl.classList.add('viewer-highlight');
        } else {
          linkEl.classList.remove('hover-preview');
          showClickInfo(linkEl);
        }
      });
    }

    // Mirrors the real widget's copy-button click handler (gra-toolkit Assistant.js): swaps the
    // icon, adds .copied-button-intf (drives the "Copied" text color via style-copied-color),
    // and rewrites the button's own text node — but manually toggled here instead of on a timer.
    function resetCopyState() {
      var copyBtnEl = wyswygEl.querySelector('.copy-button-intf');
      if (!copyBtnEl) return;
      copyBtnEl.classList.remove('copied-button-intf', 'hover-preview');
      var copyIcon = copyBtnEl.querySelector('.icon-copy-button-intf');
      var copiedIcon = copyBtnEl.querySelector('.icon-copied-button-intf');
      if (copyIcon) copyIcon.classList.remove('hidden-intf');
      if (copiedIcon) copiedIcon.classList.add('hidden-intf');
      var textNode = Array.from(copyBtnEl.childNodes).find(function(n) { return n.nodeType === Node.TEXT_NODE && n.nodeValue.trim(); });
      if (textNode) textNode.nodeValue = 'Copy';
    }

    // Hover only changes the button's text color in production (no separate hover icon), and
    // per gra-toolkit's own CSS it's only relevant while NOT copied (button.copied-button-intf:hover
    // uses the Copied color, not the Hover one) — so entering Hover resets to Normal icon/text first.
    function showCopyStatePicker(btn) {
      var copyBtnEl = btn.closest('.copy-button-intf') || btn;
      showStatePicker(btn, function(state) {
        var copyIcon = copyBtnEl.querySelector('.icon-copy-button-intf');
        var copiedIcon = copyBtnEl.querySelector('.icon-copied-button-intf');
        var textNode = Array.from(copyBtnEl.childNodes).find(function(n) { return n.nodeType === Node.TEXT_NODE && n.nodeValue.trim(); });
        // showClickInfo() calls clearClickInfo() internally, which reverts a locked preview if
        // copyStateLocked is already true — so it must run BEFORE the lock is (re-)set below.
        if (state === 'copied') {
          resetCopyState();
          copyBtnEl.classList.add('copied-button-intf');
          if (copyIcon) copyIcon.classList.add('hidden-intf');
          if (copiedIcon) copiedIcon.classList.remove('hidden-intf');
          if (textNode) textNode.nodeValue = 'Copied';
          if (copiedIcon) showClickInfo(copiedIcon);
          copyStateLocked = true;
        } else if (state === 'hover') {
          resetCopyState();
          copyBtnEl.classList.add('hover-preview');
          showClickInfo(copyBtnEl);
          copyStateLocked = true;
        } else {
          if (copyIcon) showClickInfo(copyIcon);
          resetCopyState();
          copyStateLocked = false;
        }
      }, [{label: 'Normal', state: 'normal'}, {label: 'Hover', state: 'hover'}, {label: 'Copied', state: 'copied'}]);
    }

    function switchToTabForSetting(settingId) {
      var tabHref = tabBySettingId[settingId] || defaultTabId;
      var activeLink = document.querySelector('body.edit.admin_projects ul.nav-tabs li a.active, body.edit.admin_projects ul.nav-tabs li.active a');
      if (activeLink && activeLink.getAttribute('href') === tabHref) return false;
      var tabLink = document.querySelector("body.edit.admin_projects div.tabs li a[href='" + tabHref + "']");
      if (tabLink) { suppressClearClickInfo = true; tabLink.click(); suppressClearClickInfo = false; return true; }
      return false;
    }

    function setupHoverPreview(inputSelector, targetId, isLockedFn) {
      var targetIds = Array.isArray(targetId) ? targetId : [targetId];
      var $targets = $(targetIds.map(function(id) { return '#' + id; }).join(','));
      var $inputs = $(inputSelector);
      $inputs.on('focus', function() { $targets.addClass('hover-preview'); })
             .on('blur', function() {
               setTimeout(function() {
                 var panelOpen = $inputs.toArray().some(function(input) {
                   return $(input).closest('.minicolors').find('.minicolors-panel').is(':visible');
                 });
                 if (!panelOpen) $targets.removeClass('hover-preview');
               }, 100);
             });
      $(document).on('mousedown', function(e) {
        if (!$targets.hasClass('hover-preview') || isLockedFn()) return;
        var clickedInside = $inputs.toArray().some(function(input) {
          var wrap = $(input).closest('.minicolors')[0];
          return wrap && wrap.contains(e.target);
        });
        if (!clickedInside) setTimeout(function() { $targets.removeClass('hover-preview'); }, 50);
      });
      return $inputs;
    }

    setupHoverPreview('#project_icon_send_hover_background_color, #project_icon_send_hover_color, #project_icon_send_hover_scale, #project_icon_send_hover', 'id-btn-send-question-intf', function() { return sendHoverLocked; });
    setupHoverPreview('#project_icon_chat_hover_background_color, #project_icon_chat_hover_text_color', ['icon-chat-open-wrapper-intf', 'icon-chat-open-text-intf', 'icon-chat-open-custom-intf'], function() { return chatOpenHoverLocked; });
    setupHoverPreview('#project_icon_close_hover_background_color, #project_icon_close_hover_text_color', ['icon-chat-close-wrapper-intf', 'icon-chat-close-text-intf', 'icon-chat-close-custom-intf'], function() { return chatCloseHoverLocked; });

    // Viewer click handler
    wyswygEl.addEventListener('click', function(e) {
      if (e.target.closest('a')) e.preventDefault();
      var popup = wyswygEl.querySelector('#wyswyg-click-info');
      if (popup && popup.contains(e.target)) return;
      var sendBtn = e.target.closest('#id-btn-send-question-intf');
      if (sendBtn) { showSendStatePicker(sendBtn); return; }
      var chatOpenBtn = e.target.closest('#icon-chat-open-wrapper-intf, #icon-chat-open-text-intf, #icon-chat-open-custom-intf');
      if (chatOpenBtn) { showChatOpenStatePicker(chatOpenBtn); return; }
      var chatCloseBtn = e.target.closest('#icon-chat-close-wrapper-intf, #icon-chat-close-text-intf, #icon-chat-close-custom-intf');
      if (chatCloseBtn) { showChatCloseStatePicker(chatCloseBtn); return; }
      var darkLightBtn = e.target.closest('#id-dark-light-container-intf');
      if (darkLightBtn) { showDarkLightStatePicker(darkLightBtn); return; }
      var copyBtn = e.target.closest('.copy-button-intf');
      if (copyBtn) { showCopyStatePicker(copyBtn); return; }
      var sourceBtn = e.target.closest('.url-text-link-intf');
      if (sourceBtn) { showSourceButtonStatePicker(sourceBtn); return; }
      closeStatePicker();
      var svg = e.target.closest('svg');
      if (svg && (svg.hasAttribute('data-viewer') || svg.querySelector('[data-viewer]'))) { showClickInfo(svg); return; }
      var el = findPreciseTarget(e.target, e.clientX, e.clientY);
      var tvEl = e.target.closest('[data-text-viewer]');
      if (tvEl && (!el || el.contains(tvEl))) el = tvEl;
      if (!el) { clearClickInfo(); return; }
      showClickInfo(el);
    });

    document.addEventListener('click', function(e) {
      if (!wyswygEl.contains(e.target)) {
        closeStatePicker();
        if (!suppressClearClickInfo && !e.target.closest('li[id^="project_"][id$="_input"], .color-custom-setting-link')) clearClickInfo();
      }
    });

    // Field selector events
    $(settings.fieldSelector + ' .label').on('click', function() {
      var li = $(this).closest('li[id$="_input"]')[0];
      clearClickInfo();
      if (li) applyViewerHighlight(li.id.replace(/_input$/, ''));
    });

    $(settings.fieldSelector).on('focusin', function() {
      var popup = wyswygEl.querySelector('#wyswyg-click-info');
      if ((popup && popup.style.display !== 'none' || $clickHighlightedLis.length > 0) && !$(this).hasClass('viewer-click-highlight')) clearClickInfo();
      applyViewerHighlight(this.id.replace(/_input$/, ''));
    }).on('focusout', function() {
      if (this.querySelector('select')) return;
      setTimeout(function() {
        if (!$(document.activeElement).closest('li[id^="project_"][id$="_input"], .color-custom-setting-link').length) removeViewerHighlight();
      }, 50);
    });

    // Table-driven, so a future setting on a NEW element only needs a row here (reusing an
    // existing 'hover'/'copied' kind, or adding a new kind's case below) — never a full copy of
    // this dispatch. Doesn't reuse showCopyStatePicker/showSourceButtonStatePicker's code: those
    // rely on calling showClickInfo() (which runs clearClickInfo() internally) BEFORE setting the
    // *Locked flag, specifically so the state they just entered doesn't get immediately reverted —
    // this handler instead calls clearClickInfo() once up front and never again, so it can set the
    // flag directly, right here, without worrying about that ordering.
    var CUSTOM_SETTING_PREVIEW_STATE = {
      Intf_CopyButtonHoverTextColor:         { kind: 'hover',  selector: '.copy-button-intf' },
      Intf_CopiedButtonTextColor:            { kind: 'copied', selector: '.copy-button-intf' },
      Intf_CopiedButtonIconColor:            { kind: 'copied', selector: '.copy-button-intf' },
      Intf_SourceLinkButtonColorHover:       { kind: 'hover',  selector: '.url-text-link-intf' },
      Intf_SourceLinkButtonTextColorHover:   { kind: 'hover',  selector: '.url-text-link-intf' },
      Intf_SourceLinkButtonBorderColorHover: { kind: 'hover',  selector: '.url-text-link-intf' },
    };

    function enterCustomSettingPreviewState(id) {
      var entry = CUSTOM_SETTING_PREVIEW_STATE[id];
      if (!entry) return null;
      var el = wyswygEl.querySelector(entry.selector);
      if (!el) return null;

      if (entry.kind === 'hover') {
        if (el.classList.contains('copy-button-intf')) { resetCopyState(); copyStateLocked = true; }
        else if (el.classList.contains('url-text-link-intf')) { sourceButtonHoverLocked = true; sourceButtonHoverEl = el; }
        el.classList.add('hover-preview');
      } else if (entry.kind === 'copied') {
        resetCopyState();
        el.classList.add('copied-button-intf');
        var copyIcon = el.querySelector('.icon-copy-button-intf');
        var copiedIcon = el.querySelector('.icon-copied-button-intf');
        if (copyIcon) copyIcon.classList.add('hidden-intf');
        if (copiedIcon) copiedIcon.classList.remove('hidden-intf');
        var textNode = Array.from(el.childNodes).find(function(n) { return n.nodeType === Node.TEXT_NODE && n.nodeValue.trim(); });
        if (textNode) textNode.nodeValue = 'Copied';
        copyStateLocked = true;
      }
      return el;
    }

    // Custom-setting labels listed under a color subgroup (see .color-subgroup-box__custom in
    // app/admin/projects.rb) — no project_* field/li of their own, so clicking jumps straight to
    // the same highlight + popup shown when clicking their element inside the wyswyg mockup.
    $('.color-custom-setting-link').on('click', function(e) {
      e.preventDefault();
      var id = this.dataset.customSettingId;
      if (!settings.customSettings[id]) return;
      clearClickInfo();
      checkInputWarning(id);
      var previewEl = enterCustomSettingPreviewState(id);
      if (id === 'Intf_IconScrollUp' || id === 'Intf_IconScrollUpBackgroundColor') {
        scrollToBottom();
      } else if (settings.scrollPositions.hasOwnProperty(id)) {
        scrollViewerTo(settings.scrollPositions[id]);
      }
      var targets = [];
      wyswygEl.querySelectorAll('[data-viewer~="' + id + '"], [data-custom-viewer~="' + id + '"], [data-custom-viewer-single~="' + id + '"]').forEach(function(el) {
        var target = el.ownerSVGElement ? el.closest('svg') : el;
        if (target && targets.indexOf(target) === -1) targets.push(target);
      });
      if (previewEl && targets.indexOf(previewEl) === -1) targets.push(previewEl);
      targets.forEach(function(el) { el.classList.add('viewer-highlight'); });
      $viewerHighlightedTargets = $viewerHighlightedTargets.add(targets);
      openCustomSettingPanel(id);
    });

    // Color groups (Launcher, Header, Chat Area, ...) are collapsed by default — the title toggles
    // its own group open/closed.
    $('.color-group__title').on('click', function() {
      $(this).closest('.color-group').toggleClass('collapsed');
    });

    // Boolean settings
    function setupRadioShow(name, showSel, hideSel) {
      $("input[name='project[" + name + "]']").change(function() {
        var isTrue = $("input[name='project[" + name + "]']:checked").val() === 'true';
        if (isTrue) {
          $('.wyswyg-message').hide(); $('.wyswyg-warning-setting').removeClass('wyswyg-warning-setting');
          if (showSel) $(showSel).show();
          if (hideSel) $(hideSel).hide();
        } else {
          if (showSel) $(showSel).hide();
          if (hideSel) $(hideSel).show();
        }
      }).change();
    }

    function setupSelectNoDisplay(id, targetSel, onChangeFn) {
      $('#project_' + id).change(function() {
        var hidden = $(this).val() === 'true';
        $(targetSel).css('display', hidden ? 'none' : '');
        if (onChangeFn) onChangeFn();
        $('.wyswyg-message').hide(); $('.wyswyg-warning-setting').removeClass('wyswyg-warning-setting');
      }).change();
    }

    setupRadioShow('feedback',         '.thumb-block-intf');
    setupRadioShow('copy',             '.copy-block-intf');
    setupRadioShow('theme_switch',     '#id-dark-light-container-intf');
    setupRadioShow('font_size_switch', '#id-font-size-container-intf');
    setupRadioShow('resize',           '#id-resize-container-intf');
    setupRadioShow('source_button',    '#source-button-example-intf', '#source-button-disabled-example-intf');

    setupSelectNoDisplay('icon_question_no_display',       '#icon-question-container-gra');
    setupSelectNoDisplay('icon_answer_no_display',         '#icon-answer-container-gra, #icon-first-message-container-gra');
    function applyIconInputQuestionPadding() {
      var hidden = $('#project_icon_input_question_no_display').val() === 'true';
      $(wyswygEl).find(questionInputSel).css('padding-left', hidden ? '10px' : '');
    }
    setupSelectNoDisplay('icon_input_question_no_display', '#icon-input-question-default-gra, #icon-input-question-custom-gra', applyIconInputQuestionPadding);

    $("#project_typing_label_position").change(function(e) {
      var val = $(this).val();
      var visibleBlockId = null;
      if (['above-input-box', 'above-input-text-only', 'instead-message-text-only'].includes(val)) { $("#typing-label-text-intf").show(); $("#typing-label-text-and-dots-intf").hide(); $("#typing-label-dots-intf").hide(); visibleBlockId = 'typing-label-text-intf'; }
      if (['above-input-text-and-dots', 'instead-message-text-and-dots', 'above-input-box-with-dots'].includes(val)) { $("#typing-label-text-intf").hide(); $("#typing-label-text-and-dots-intf").show(); $("#typing-label-dots-intf").hide(); visibleBlockId = 'typing-label-text-and-dots-intf'; }
      if (['instead-message', 'instead-message-dots-only', 'above-input-dots-only'].includes(val)) { $("#typing-label-text-intf").hide(); $("#typing-label-text-and-dots-intf").hide(); $("#typing-label-dots-intf").show(); visibleBlockId = 'typing-label-dots-intf'; }
      $('.wyswyg-message').hide(); $('.wyswyg-warning-setting').removeClass('wyswyg-warning-setting');
      if (e.originalEvent && visibleBlockId) {
        var targetEl = wyswygEl.querySelector('#' + visibleBlockId + '[data-viewer], #' + visibleBlockId + ' [data-viewer]');
        if (targetEl) showClickInfo(targetEl);
      }
    }).change();

    $('#project_form_block_position').on('change', function() {
      var isTop = $(this).val() === 'top';
      var container = document.getElementById('chat_block_gra');
      if (!container) return;
      container.classList.toggle('form-block-top-intf', isTop);
      var scrollUp = document.getElementById('icon-scroll-up-intf');
      var scrollDown = document.getElementById('icon-scroll-down-intf');
      var target = isTop
        ? wyswygEl.querySelector('.footer_disclaimer_gra')
        : document.getElementById('form_assistant');
      if (scrollUp && scrollDown && target) {
        target.insertBefore(scrollUp, target.firstChild);
        target.insertBefore(scrollDown, scrollUp.nextSibling);
      }
    }).change();

    (function() {
      var $formInputType = $('#project_form_input_type');
      if (!$formInputType.length) return;
      function reapplyQuestionFieldStyles(el) {
        (el.getAttribute('data-viewer') || '').trim().split(/\s+/).forEach(function(id) {
          if (settings.viewerIdStyles[id]) setViewerSettings($('#' + id), true);
        });
      }
      function applyFormInputType(value) {
        var current = wyswygEl.querySelector(questionInputSel);
        if (!current) return;
        var wantTextarea = value === 'textarea';
        if (wantTextarea === (current.tagName === 'TEXTAREA')) return;
        var replacement = document.createElement(wantTextarea ? 'textarea' : 'input');
        Array.prototype.forEach.call(current.attributes, function(attr) {
          if (attr.name !== 'style') replacement.setAttribute(attr.name, attr.value);
        });
        if (!wantTextarea) replacement.type = 'text';
        replacement.value = current.value;
        current.parentNode.replaceChild(replacement, current);
        reapplyQuestionFieldStyles(replacement);
        applyIconInputQuestionPadding();
      }
      $formInputType.on('change', function() { applyFormInputType($(this).val()); });
      applyFormInputType($formInputType.val());
    })();

    // Text viewer fields
    settings.textViewerFields.forEach(function(prop) {
      $('#project_' + prop).on('input', function() { $('[data-text-viewer="' + prop + '"]').text($(this).val()); });
    });

    var messageContainerEl = wyswygEl.querySelector('.message-container-intf');
    var messageContainerBaseViewer = messageContainerEl ? messageContainerEl.getAttribute('data-viewer') : null;

    $('#project_hint_message').on('input', function() {
      var hasText = !!$(this).val().trim();
      if (hasText) { $('#hint-block-container-intf').show(); } else { $('#hint-block-container-intf').hide(); }
      // When the hint is hidden, #hint-wrapper-intf isn't clickable/visible, so there's no way to
      // reach its settings from the preview - route clicks on the general message container to the
      // Hint message field instead, until it's filled in and the hint renders again.
      if (messageContainerEl) {
        messageContainerEl.setAttribute('data-viewer', hasText ? messageContainerBaseViewer : (messageContainerBaseViewer + ' project_hint_message'));
      }
    }).trigger('input');

    // Viewer value fields
    settings.viewerValueFields.forEach(function(prop) {
      var item = $('#project_' + prop);
      item.on('input', function() { setViewerSettings(item); });
      setViewerSettings(item);
    });

    // The font-scale rule (see updateViewerFonts) computes the question input's/typing text's/
    // title's/subtitle's font-size from these fields' current values — recompute it when any of
    // them changes too, otherwise a stale scale factor keeps overriding it (via !important)
    // with the old base.
    $('#project_base_font_size_input_field').on('input', updateViewerFonts);
    $('#project_base_font_size_typing_text').on('input', updateViewerFonts);
    $('#project_base_font_size_title').on('input', updateViewerFonts);
    $('#project_base_font_size_subtitle').on('input', updateViewerFonts);

    $('#project_question_placeholder_text').on('input', function() {
      $(questionInputSel).attr('placeholder', $(this).val() + ' *');
    });

    $('#project_first_message_text').on('input', function() {
      var text = $(this).val().trim();
      if (text) { $('#hello-block-intf').hide(); $('#first-message-wrapper-intf .answer-intf p[data-viewer]').text(text); $('#first-message-wrapper-intf').show(); }
      else { $('#first-message-wrapper-intf').hide(); $('#hello-block-intf').show(); }
    }).trigger('input');

    // Text icon generation
    function buildTextIconSvg(text, tl, isHover, viewerIds, customViewerId, gradientId, fontSizeId, extraClass, lengthFieldId, prefix) {
      prefix = prefix || 'project_icon_chat';
      var lines = text.split('\n').filter(function(l) { return l.trim(); });
      var viewBox = '0 0 ' + (tl + 65) + ' 65';
      var textColorAttr = 'data-viewer="' + (isHover ? prefix + '_hover_text_color' : prefix + '_text_color') + (fontSizeId ? ' ' + fontSizeId : '') + '"';
      var gid = gradientId || 'linear-gradient-chat-icon-text';
      var defs = isHover ? '' :
        '<defs><linearGradient id="' + gid + '" gradientUnits="objectBoundingBox" x1="0.5" x2="0.5" y2="1">' +
        '<stop data-viewer="' + prefix + '_background_color_from" offset="0" stop-color="#81b56b"></stop>' +
        '<stop data-viewer="' + prefix + '_background_color_to" offset="1" stop-color="#81b56b"></stop>' +
        '</linearGradient></defs>';
      var bgAttr = isHover ? 'data-viewer="' + prefix + '_hover_background_color" fill="#5d8f52"' : 'fill="url(#' + gid + ')"';
      var textEls = lines.map(function(line, i) {
        var y = (100 * (i + 1) / (lines.length + 1)) + '%';
        var x = lines.length === 1 ? '50%' : '10%';
        var anchor = lines.length === 1 ? 'middle' : 'start';
        return '<text dominant-baseline="middle" font-size="16" font-family="Intftext ,sans-serif" font-weight="bold" style="font-size:16px;font-family:Intftext,sans-serif;font-weight:bold;" fill="#ffffff" ' + textColorAttr + ' x="' + x + '" y="' + y + '" text-anchor="' + anchor + '">' + line + '</text>';
      }).join('');
      var viewerAttr = viewerIds ? ' data-viewer="' + viewerIds + '"' : '';
      var midViewerAttr = isHover ? '' : 'data-viewer="' + (lengthFieldId || 'project_text_icon_length') + '" ';
      var customViewerAttr = customViewerId ? ' data-custom-viewer-single="' + customViewerId + '"' : '';
      var cls = 'icon-intf' + (extraClass ? ' ' + extraClass : (isHover ? ' hidden-intf' : ''));
      return '<svg class="' + cls + '"' + viewerAttr + customViewerAttr + ' aria-label="Open" viewBox="' + viewBox + '">' +
        defs +
        '<path d="M 18 0 H 18 V 64 H 18 A 18 18 0 0 1 0 46 V 18 A 18 18 0 0 1 18 0 Z" ' + bgAttr + ' transform="translate(2 0)"></path>' +
        '<path d="M 18 0 H ' + (tl + 46) + ' V 64 H 18 Z" ' + midViewerAttr + 'data-text-icon-mid="true" ' + bgAttr + ' transform="translate(1 0)"></path>' +
        '<path d="M 46 0 H 46 A 18 18 0 0 1 64 18 V 58 a 6 6 0 0 1 -6 6 H 46 Z" ' + bgAttr + ' data-text-icon-right="true" transform="translate(' + tl + ' 0)"></path>' +
        textEls +
        '<path d="M 20 0 H ' + (tl + 46) + ' A 18 18 0 0 1 ' + (tl + 64) + ' 18 V 58 a 6 6 0 0 1 -6 6 H 20 A 18 18 0 0 1 2 46 V 18 A 18 18 0 0 1 20 0 Z" fill="none" stroke="none" stroke-width="2" data-viewer="project_icons_chat_close_border_color"></path>' +
        '</svg>';
    }

    function rebuildTextIcons() {
      var openText  = ($('#project_text_icon_text').val()       || '').trim();
      var closeText = ($('#project_text_icon_close_text').val() || '').trim();
      var openMobileText = ($('#project_text_icon_mobile_text').val() || '').trim();
      var tl = parseInt($('#project_text_icon_length').val() || '') || 90;

      var openContainer  = document.getElementById('icon-chat-open-text-intf');
      var closeContainer = document.getElementById('icon-chat-close-text-intf');
      var openWrapper    = document.getElementById('icon-chat-open-wrapper-intf');
      var closeWrapper   = document.getElementById('icon-chat-close-wrapper-intf');

      if (!$('#icon-chat-open-custom-intf').is(':visible')) {
        if (openText) {
          if (openContainer)  {
            $(openContainer).html(
              buildTextIconSvg(openText, tl, false, 'project_text_icon_text project_text_icon_length project_start_chat_icon project_close_open_icons_scale', null, 'linear-gradient-chat-icon-text-open', 'project_text_icon_font_size') +
              buildTextIconSvg(customSettingValues['Intf_IconChatHoverFullText'] || openText, tl, true, 'project_close_open_icons_scale', 'Intf_IconChatHoverTextFontSize Intf_IconChatHoverFullText') +
              buildTextIconSvg(openMobileText || openText, tl, false, 'project_text_icon_mobile_text project_text_icon_mobile_length project_start_chat_icon', 'Intf_iconSizeScaleMobile Intf_IconChatTextMobileFontSize', 'linear-gradient-chat-icon-text-open-mobile-normal', null, 'mobile-preview mobile-normal-intf', 'project_text_icon_mobile_length') +
              buildTextIconSvg(customSettingValues['Intf_IconChatMobileHoverFullText'] || customSettingValues['Intf_IconChatHoverFullText'] || openText, tl, true, null, 'Intf_iconSizeScaleMobile Intf_IconChatHoverTextMobileFontSize Intf_IconChatMobileHoverFullText', null, null, 'mobile-preview mobile-hover-intf')
            ).show();
          }
          if (openWrapper)    { $(openWrapper).hide(); }
          // The freshly built SVGs above start out at the desktop length/font-size/no-scale — re-apply
          // every hover/mobile custom setting that isn't baked directly into the build call's text/viewBox.
          applyMobileTextIconLength($('#project_text_icon_mobile_length').val());
          ['Intf_IconChatHoverTextFontSize', 'Intf_iconSizeScaleMobile', 'Intf_IconChatTextMobileFontSize', 'Intf_IconChatHoverTextMobileFontSize'].forEach(function(id) {
            var openMobileSetting = settings.customSettings[id];
            if (openMobileSetting && openMobileSetting.onChange) openMobileSetting.onChange(customSettingValues[id]);
          });
        } else {
          if (openContainer)  { $(openContainer).hide(); }
          if (openWrapper)    { $(openWrapper).show(); }
        }
      }
      if (!$('#icon-chat-close-custom-intf').is(':visible')) {
        if (closeText) {
          if (closeContainer) { $(closeContainer).html(buildTextIconSvg(closeText, tl, false, 'project_text_icon_close_text project_text_icon_length project_running_chat_icon project_close_open_icons_scale', null, 'linear-gradient-chat-icon-text-close', 'project_text_icon_close_font_size', null, null, 'project_icon_close') + buildTextIconSvg(customSettingValues['Intf_IconCloseHoverFullText'] || closeText, tl, true, 'project_close_open_icons_scale', 'Intf_IconCloseHoverTextFontSize Intf_IconCloseHoverFullText', null, null, null, null, 'project_icon_close')).show(); }
          if (closeWrapper)   { $(closeWrapper).hide(); }
          var closeHoverFontSetting = settings.customSettings['Intf_IconCloseHoverTextFontSize'];
          if (closeHoverFontSetting && closeHoverFontSetting.onChange) closeHoverFontSetting.onChange(customSettingValues['Intf_IconCloseHoverTextFontSize']);
        } else {
          if (closeContainer) { $(closeContainer).hide(); }
          if (closeWrapper)   { $(closeWrapper).show(); }
        }
      }
      if (openText || closeText) {
        ['project_icon_chat_background_color_from', 'project_icon_chat_background_color_to',
         'project_icon_chat_text_color', 'project_icon_chat_hover_background_color',
         'project_icon_chat_hover_text_color', 'project_icon_close_background_color_from',
         'project_icon_close_background_color_to', 'project_icon_close_text_color',
         'project_icon_close_hover_background_color', 'project_icon_close_hover_text_color',
         'project_icons_chat_close_border_color', 'project_close_open_icons_scale'
        ].forEach(function(id) { setViewerSettings($('#' + id), true); });
      }
      updateIconBlockStacking();
    }

    $('#project_text_icon_text, #project_text_icon_close_text, #project_text_icon_length, #project_text_icon_mobile_text').on('input change', function() { rebuildTextIcons(); });

    $('#project_text_icon_font_size, #project_text_icon_close_font_size').on('input change', function() {
      setViewerSettings($(this));
    }).each(function() { setViewerSettings($(this), true); });

    $('#project_text_icon_mobile_length').on('input change', function() {
      setViewerSettings($(this));
    }).each(function() { setViewerSettings($(this), true); });

    // Init from container data attrs (custom icons)
    function insertCustomAnswerIcon(svgHtml) {
      removeCustomAnswerIcon();
      var $svg = $(svgHtml);
      $svg.attr('id', 'answer-icon-custom')
          .attr('data-viewer', 'project_answer_icon project_icon_answer_scale_assistant')
          .addClass('icon-answer-intf')
          .attr({ width: '50', height: '50' });
      $('#answer-icon-default').addClass('hidden-intf').after($svg);
      var $svgClone = $svg.clone().attr('id', 'first-message-answer-icon-custom');
      $('#first-message-answer-icon-default').addClass('hidden-intf').after($svgClone);
      setViewerSettings($('#project_icon_answer_scale_assistant'));
    }

    function removeCustomAnswerIcon() {
      $('#answer-icon-custom, #first-message-answer-icon-custom').remove();
      $('#answer-icon-default, #first-message-answer-icon-default').removeClass('hidden-intf');
    }

    function applyBackgroundImage() {
      var $container = $(wyswygEl).find('.message-container-intf');
      if (!currentBackgroundImageDataUrl) {
        $container.css('background-image', '');
        return;
      }
      // Fades the image toward white without touching the container's own
      // opacity (which would also fade its text/icons/children).
      var alpha = Math.min(Math.max(currentBackgroundImageTransparency, 0), 100) / 100;
      var overlay = 'linear-gradient(rgba(255,255,255,' + alpha + '), rgba(255,255,255,' + alpha + '))';
      $container.css('background-image', overlay + ', url(' + currentBackgroundImageDataUrl + ')');
    }

    function insertBackgroundImage(dataUrl) {
      currentBackgroundImageDataUrl = dataUrl;
      applyBackgroundImage();
    }

    function removeBackgroundImage() {
      currentBackgroundImageDataUrl = '';
      applyBackgroundImage();
    }

    function insertCustomChatOpenIcon(svgHtml) {
      var $svg = $(svgHtml);
      $svg.addClass('icon-intf')
        .attr('data-viewer', 'project_start_chat_icon project_close_open_icons_scale');
      $('#icon-chat-open-custom-intf').empty().append($svg).show();
      $('#icon-chat-open-wrapper-intf, #icon-chat-open-text-intf').hide();
      setViewerSettings($('#project_close_open_icons_scale'));
    }

    function removeCustomChatOpenIcon() {
      $('#icon-chat-open-custom-intf').empty().hide();
      rebuildTextIcons();
    }

    function insertCustomChatCloseIcon(svgHtml) {
      var $svg = $(svgHtml);
      $svg.addClass('icon-intf').attr('data-viewer', 'project_running_chat_icon project_close_open_icons_scale');
      $('#icon-chat-close-custom-intf').empty().append($svg).show();
      $('#icon-chat-close-wrapper-intf, #icon-chat-close-text-intf').hide();
      setViewerSettings($('#project_close_open_icons_scale'));
    }

    function removeCustomChatCloseIcon() {
      $('#icon-chat-close-custom-intf').empty().hide();
      rebuildTextIcons();
    }

    // GRA custom icon handlers

    // jQuery's $(svgHtml) parses via innerHTML (HTML rules), which does NOT resolve XML
    // namespace prefixes on element names — an uploaded <ns0:path> (with xmlns:ns0 pointing
    // at the SVG namespace, as some export tools produce) ends up as a literal "ns0:path"
    // element that the renderer doesn't recognize as <path>: present in the DOM, draws nothing.
    // Parsing as real XML resolves the prefix correctly. Falls back to the lenient HTML parse
    // for files that aren't strictly well-formed XML (unescaped &, missing quotes, etc.).
    function parseUploadedSvg(svgHtml) {
      try {
        var doc = new DOMParser().parseFromString(svgHtml, 'image/svg+xml');
        if (doc.querySelector('parsererror')) throw new Error('invalid xml');
        return document.importNode(doc.documentElement, true);
      } catch (e) {
        var $fallback = $(svgHtml).filter(function() { return this.nodeType === 1; });
        return $fallback.length ? $fallback[0] : null;
      }
    }

    function insertGraIcon(svgHtml, defaultId, customId, cssClasses, scaleViewerId) {
      var svgEl = parseUploadedSvg(svgHtml);
      if (!svgEl) return;
      // Uploaded files may also carry their own inline style (display:none, zero width/height
      // — common for icons exported as <symbol> sprites); clear it so our positioning CSS
      // classes can apply.
      svgEl.style.removeProperty('display');
      svgEl.style.removeProperty('visibility');
      svgEl.style.removeProperty('width');
      svgEl.style.removeProperty('height');
      var $svg = $(svgEl);
      cssClasses.split(' ').forEach(function(c) { if (c) $svg.addClass(c); });
      if (scaleViewerId) $svg.attr('data-viewer', scaleViewerId);
      $svg.attr('id', customId);
      $(wyswygEl).find('#' + customId).replaceWith($svg);
      $(wyswygEl).find('#' + defaultId).addClass('hidden-intf');
    }
    function removeGraIcon(defaultId, customId, cssClasses) {
      var emptyClasses = cssClasses + ' hidden-intf';
      $(wyswygEl).find('#' + customId).replaceWith(
        $('<svg>').attr('id', customId).attr('class', emptyClasses)
      );
      $(wyswygEl).find('#' + defaultId).removeClass('hidden-intf');
    }

    function insertGraInputQuestionIcon(svgHtml) {
      insertGraIcon(svgHtml, 'icon-input-question-default-gra', 'icon-input-question-custom-gra', 'icon-intf_gra icon-input-question_intf_gra', 'project_icon_input_question_scale project_icon_input_question project_icon_input_question_no_display');
      setViewerSettings($('#project_icon_input_question_scale'));
    }
    function removeGraInputQuestionIcon() {
      removeGraIcon('icon-input-question-default-gra', 'icon-input-question-custom-gra', 'icon-intf_gra icon-input-question_intf_gra');
    }

    function insertGraSendIcon(svgHtml) {
      insertGraIcon(svgHtml, 'icon-send-default-gra', 'icon-send-custom-gra', 'icon-intf_gra icon-send_intf_gra', 'project_icon_send_scale project_icon_send');
      setViewerSettings($('#project_icon_send_scale'));
    }
    function removeGraSendIcon() {
      removeGraIcon('icon-send-default-gra', 'icon-send-custom-gra', 'icon-intf_gra icon-send_intf_gra');
    }

    function insertGraSendHoverIcon(svgHtml) {
      insertGraIcon(svgHtml, 'icon-send-hover-default-gra', 'icon-send-hover-custom-gra', 'icon-intf_gra icon-send-hover_intf_gra', 'project_icon_send_hover_scale project_icon_send_hover');
      setViewerSettings($('#project_icon_send_hover_scale'));
      $(wyswygEl).find('#icon-send-hover-custom-gra').css('display', 'none');
    }
    function removeGraSendHoverIcon() {
      removeGraIcon('icon-send-hover-default-gra', 'icon-send-hover-custom-gra', 'icon-intf_gra icon-send-hover_intf_gra');
    }

    function insertGraAnswerIcon(svgHtml) {
      $(wyswygEl).find('#icon-answer-custom-gra').remove();
      var $svg = $(svgHtml).addClass('icon-answer-intf').attr({ id: 'icon-answer-custom-gra', width: '28', height: '28', 'data-viewer': 'project_answer_icon project_icon_answer_scale project_icon_answer_no_display' });
      $(wyswygEl).find('#icon-answer-default-gra').addClass('hidden-intf').after($svg);
      $(wyswygEl).find('#icon-first-message-custom-gra').remove();
      var $svgFm = $(svgHtml).addClass('icon-answer-intf').attr({ id: 'icon-first-message-custom-gra', width: '28', height: '28', 'data-viewer': 'project_answer_icon project_icon_answer_scale project_icon_answer_no_display' });
      $(wyswygEl).find('#icon-first-message-default-gra').addClass('hidden-intf').after($svgFm);
      setViewerSettings($('#project_icon_answer_scale'));
    }
    function removeGraAnswerIcon() {
      $(wyswygEl).find('#icon-answer-custom-gra').remove();
      $(wyswygEl).find('#icon-answer-default-gra').removeClass('hidden-intf');
      $(wyswygEl).find('#icon-first-message-custom-gra').remove();
      $(wyswygEl).find('#icon-first-message-default-gra').removeClass('hidden-intf');
    }

    function insertGraQuestionIcon(svgHtml) {
      $(wyswygEl).find('#icon-question-custom-gra').remove();
      var $svg = $(svgHtml).addClass('icon-question-intf').attr({ id: 'icon-question-custom-gra', width: '28', height: '28', 'data-viewer': 'project_question_icon project_icon_question_scale project_icon_question_no_display' });
      $(wyswygEl).find('#icon-question-default-gra').addClass('hidden-intf').after($svg);
      setViewerSettings($('#project_icon_question_scale'));
    }
    function removeGraQuestionIcon() {
      $(wyswygEl).find('#icon-question-custom-gra').remove();
      $(wyswygEl).find('#icon-question-default-gra').removeClass('hidden-intf');
    }

    // Tail icons (Display answer and question tails icons)
    var tailViewerAttr = 'project_icon_tails_answer_question project_icon_tails_answer_link';
    var tailQuestionViewerAttr = 'project_icon_tails_answer_question project_icon_tails_question_link';

    function insertGraTailAnswerIcon(svgHtml) {
      insertGraIcon(svgHtml, 'icon-tail-answer-default-gra', 'icon-tail-answer-custom-gra', 'icon-tail-answer-intf_gra', tailViewerAttr);
      insertGraIcon(svgHtml, 'icon-tail-first-message-default-gra', 'icon-tail-first-message-custom-gra', 'icon-tail-answer-intf_gra', tailViewerAttr);
      updateTailPositions();
      updateTailsMasterVisibility();
    }
    function removeGraTailAnswerIcon() {
      removeGraIcon('icon-tail-answer-default-gra', 'icon-tail-answer-custom-gra', 'icon-tail-answer-intf_gra');
      removeGraIcon('icon-tail-first-message-default-gra', 'icon-tail-first-message-custom-gra', 'icon-tail-answer-intf_gra');
      updateTailPositions();
      updateTailsMasterVisibility();
    }

    function insertGraTailQuestionIcon(svgHtml) {
      insertGraIcon(svgHtml, 'icon-tail-question-default-gra', 'icon-tail-question-custom-gra', 'icon-tail-question-intf_gra', tailQuestionViewerAttr);
      updateTailPositions();
      updateTailsMasterVisibility();
    }
    function removeGraTailQuestionIcon() {
      removeGraIcon('icon-tail-question-default-gra', 'icon-tail-question-custom-gra', 'icon-tail-question-intf_gra');
      updateTailPositions();
      updateTailsMasterVisibility();
    }

    function updateTailsMasterVisibility() {
      var shown = $('#project_icon_tails_answer_question').val() === 'true';
      wyswygEl.querySelectorAll('.icon-tail-answer-intf_gra, .icon-tail-question-intf_gra').forEach(function(el) {
        if (shown) { el.style.removeProperty('display'); } else { el.style.setProperty('display', 'none', 'important'); }
      });
    }

    // Tail icons live in the outer (non-scrolling) wrapper so they aren't clipped by the
    // bubble's own overflow-x:auto (which forces overflow-y:auto too, per the CSS spec).
    // The vertical offset is measured from the actual rendered gap between the wrapper and
    // the bubble (rather than assuming a fixed margin), so it self-corrects regardless of
    // the bubble's own margins (e.g. the question bubble's margin-top/bottom: 12px).
    // Each tail icon resolves its OWN wrapper/bubble via closest()/querySelector() scoped to
    // that wrapper, rather than a page-wide selector — .answer-wrapper-intf_gra exists twice
    // (regular answer + first message), so a global selector could measure the wrong instance.
    function updateTailPosition(tailIds, wrapperClass, bubbleClass, side) {
      tailIds.forEach(function(id) {
        var el = document.getElementById(id);
        if (!el) return;
        var wrapper = el.closest('.' + wrapperClass);
        var bubble = wrapper && wrapper.querySelector('.' + bubbleClass);
        if (!wrapper || !bubble) return;
        var radius = parseFloat(bubble.style[side === 'left' ? 'borderBottomLeftRadius' : 'borderBottomRightRadius']) || 0;
        var offset = radius > 10 ? (radius - 10) : -5;
        var wrapperRect = wrapper.getBoundingClientRect();
        var bubbleRect = bubble.getBoundingClientRect();
        var bottomOffset = (wrapperRect.bottom - bubbleRect.bottom) - 5;
        el.style[side] = offset + 'px';
        el.style.bottom = bottomOffset + 'px';
      });
    }

    function updateTailPositions() {
      updateTailPosition(['icon-tail-answer-default-gra', 'icon-tail-answer-custom-gra'], 'answer-wrapper-intf_gra', 'answer-wrapper-inside-intf_gra', 'left');
      updateTailPosition(['icon-tail-first-message-default-gra', 'icon-tail-first-message-custom-gra'], 'answer-wrapper-intf_gra', 'answer-wrapper-inside-intf_gra', 'left');
      updateTailPosition(['icon-tail-question-default-gra', 'icon-tail-question-custom-gra'], 'question-wrapper-intf_gra', 'question-intf_gra', 'right');
    }

    function updateTailColors() {
      var answerColor = $('#project_answer_background_color').val() || '#fff';
      var questionColor = $('#project_question_background_color').val() || '#fff';
      ['icon-tail-answer-default-gra', 'icon-tail-first-message-default-gra'].forEach(function(id) {
        var el = document.getElementById(id);
        var path = el && el.querySelector('path');
        if (path) path.setAttribute('fill', answerColor);
      });
      var questionEl = document.getElementById('icon-tail-question-default-gra');
      var questionPath = questionEl && questionEl.querySelector('path');
      if (questionPath) questionPath.setAttribute('fill', questionColor);
    }

    function initFromData() {
      var answerIconHtml = $(wyswygEl).data('answer-icon') || '';
      if (answerIconHtml) { insertCustomAnswerIcon(answerIconHtml); insertGraAnswerIcon(answerIconHtml); }
      var chatOpenIconHtml = $(wyswygEl).data('chat-open-icon') || '';
      if (chatOpenIconHtml) { insertCustomChatOpenIcon(chatOpenIconHtml); }
      var chatCloseIconHtml = $(wyswygEl).data('chat-close-icon') || '';
      if (chatCloseIconHtml) { insertCustomChatCloseIcon(chatCloseIconHtml); }
      var iconInputQuestionHtml = $(wyswygEl).data('icon-input-question') || '';
      if (iconInputQuestionHtml) { insertGraInputQuestionIcon(iconInputQuestionHtml); }
      var iconSendHtml = $(wyswygEl).data('icon-send') || '';
      if (iconSendHtml) { insertGraSendIcon(iconSendHtml); }
      var iconSendHoverHtml = $(wyswygEl).data('icon-send-hover') || '';
      if (iconSendHoverHtml) { insertGraSendHoverIcon(iconSendHoverHtml); }
      var iconQuestionHtml = $(wyswygEl).data('icon-question') || '';
      if (iconQuestionHtml) { insertGraQuestionIcon(iconQuestionHtml); }
      var iconTailsAnswerLinkHtml = $(wyswygEl).data('icon-tails-answer-link') || '';
      if (iconTailsAnswerLinkHtml) { insertGraTailAnswerIcon(iconTailsAnswerLinkHtml); }
      var iconTailsQuestionLinkHtml = $(wyswygEl).data('icon-tails-question-link') || '';
      if (iconTailsQuestionLinkHtml) { insertGraTailQuestionIcon(iconTailsQuestionLinkHtml); }
      var backgroundImageBase64 = $(wyswygEl).data('background-image-link') || '';
      if (backgroundImageBase64) { insertBackgroundImage('data:image/jpeg;base64,' + backgroundImageBase64); }
      rebuildTextIcons();
    }

    var backgroundImageTransparencyInput = document.getElementById('project_background_image_transparency');
    if (backgroundImageTransparencyInput) {
      currentBackgroundImageTransparency = parseFloat(backgroundImageTransparencyInput.value) || 0;
      backgroundImageTransparencyInput.addEventListener('input', function() {
        currentBackgroundImageTransparency = parseFloat(this.value) || 0;
        applyBackgroundImage();
      });
    }

    initFromData();

    var savedAnswerIconHtml = $(wyswygEl).data('answer-icon') || '';
    var answerIconInput = document.getElementById('project_answer_icon');
    if (answerIconInput) {
      answerIconInput.addEventListener('change', function() {
        var file = this.files[0];
        if (file) {
          var reader = new FileReader();
          reader.onload = function(e) { insertCustomAnswerIcon(e.target.result); insertGraAnswerIcon(e.target.result); };
          reader.readAsText(file);
        } else if (savedAnswerIconHtml) {
          insertCustomAnswerIcon(savedAnswerIconHtml); insertGraAnswerIcon(savedAnswerIconHtml);
        } else {
          removeCustomAnswerIcon(); removeGraAnswerIcon();
        }
      });
    }

    var savedBackgroundImageDataUrl = $(wyswygEl).data('background-image-link')
      ? 'data:image/jpeg;base64,' + $(wyswygEl).data('background-image-link')
      : '';
    var backgroundImageInput = document.getElementById('project_background_image_link');
    if (backgroundImageInput) {
      backgroundImageInput.addEventListener('change', function() {
        var file = this.files[0];
        if (file) {
          var reader = new FileReader();
          reader.onload = function(e) { insertBackgroundImage(e.target.result); };
          reader.readAsDataURL(file);
        } else if (savedBackgroundImageDataUrl) {
          insertBackgroundImage(savedBackgroundImageDataUrl);
        } else {
          removeBackgroundImage();
        }
      });
    }

    function makeGraIconListener(inputId, savedHtml, insertFn, removeFn) {
      var input = document.getElementById(inputId);
      if (!input) return;
      input.addEventListener('change', function() {
        var file = this.files[0];
        if (file) {
          var reader = new FileReader();
          reader.onload = function(e) { insertFn(e.target.result); };
          reader.readAsText(file);
        } else if (savedHtml) {
          insertFn(savedHtml);
        } else {
          removeFn();
        }
      });
    }

    makeGraIconListener('project_icon_input_question', $(wyswygEl).data('icon-input-question') || '', insertGraInputQuestionIcon, removeGraInputQuestionIcon);
    makeGraIconListener('project_icon_send',           $(wyswygEl).data('icon-send') || '',               insertGraSendIcon,             removeGraSendIcon);
    makeGraIconListener('project_icon_send_hover',     $(wyswygEl).data('icon-send-hover') || '',         insertGraSendHoverIcon,         removeGraSendHoverIcon);
    makeGraIconListener('project_question_icon',       $(wyswygEl).data('icon-question') || '',           insertGraQuestionIcon,          removeGraQuestionIcon);
    makeGraIconListener('project_icon_tails_answer_link',   $(wyswygEl).data('icon-tails-answer-link') || '',   insertGraTailAnswerIcon,   removeGraTailAnswerIcon);
    makeGraIconListener('project_icon_tails_question_link', $(wyswygEl).data('icon-tails-question-link') || '', insertGraTailQuestionIcon, removeGraTailQuestionIcon);

    var savedChatOpenIconHtml = $(wyswygEl).data('chat-open-icon') || '';
    var chatOpenIconInput = document.getElementById('project_start_chat_icon');
    if (chatOpenIconInput) {
      chatOpenIconInput.addEventListener('change', function() {
        var file = this.files[0];
        if (file) {
          var reader = new FileReader();
          reader.onload = function(e) { insertCustomChatOpenIcon(e.target.result); };
          reader.readAsText(file);
        } else if (savedChatOpenIconHtml) {
          insertCustomChatOpenIcon(savedChatOpenIconHtml);
        } else {
          removeCustomChatOpenIcon();
        }
      });
    }

    var savedChatCloseIconHtml = $(wyswygEl).data('chat-close-icon') || '';
    var chatCloseIconInput = document.getElementById('project_running_chat_icon');
    if (chatCloseIconInput) {
      chatCloseIconInput.addEventListener('change', function() {
        var file = this.files[0];
        if (file) {
          var reader = new FileReader();
          reader.onload = function(e) { insertCustomChatCloseIcon(e.target.result); };
          reader.readAsText(file);
        } else if (savedChatCloseIconHtml) {
          insertCustomChatCloseIcon(savedChatCloseIconHtml);
        } else {
          removeCustomChatCloseIcon();
        }
      });
    }

    // Apply custom settings values from ace editor on load
    (function() {
      var container = document.querySelector('#project_custom_js_input .ace-editor-container');
      if (!container) return;
      try {
        var editor = ace.edit(container);
        var code = editor.session.getValue();
        Object.keys(settings.customSettings).forEach(function(id) {
          var match = code.match(new RegExp('global\\.' + id + '\\s*=\\s*(?:[\'"]([^\'"]*)[\'"]|(-?\\d+(?:\\.\\d+)?))\\s*;'));
          if (match) {
            var value = match[1] !== undefined ? (NEWLINE_AS_BR_SETTING_IDS.indexOf(id) !== -1 ? match[1].replace(/<br\s*\/?>/gi, '\n') : match[1].replace(/\\n/g, '\n')) : match[2];
            customSettingValues[id] = value;
            setViewerSettings($('<input type="hidden">').attr('id', id).val(value), true);
            var setting = settings.customSettings[id];
            if (setting && setting.onChange) setting.onChange(value);
          }
        });
      } catch(ex) {}
    })();

    // Custom code sync (runs after initAceEditors on window load)
    $(window).on('load', function() {
      var container = document.querySelector('#project_custom_js_input .ace-editor-container');
      if (!container) return;
      try {
        var editor = ace.edit(container);
        var syncTimer;
        editor.session.on('change', function() {
          clearTimeout(syncTimer);
          syncTimer = setTimeout(function() {
            var code = editor.session.getValue();
            Object.keys(settings.customSettings).forEach(function(id) {
              var regex = new RegExp('global\\.' + id + '\\s*=\\s*(?:[\'"]([^\'"]*)[\'"]|(-?\\d+(?:\\.\\d+)?))\\s*;');
              var match = code.match(regex);
              var value = match ? (match[1] !== undefined ? (NEWLINE_AS_BR_SETTING_IDS.indexOf(id) !== -1 ? match[1].replace(/<br\s*\/?>/gi, '\n') : match[1].replace(/\\n/g, '\n')) : match[2]) : '';
              var prevValue = customSettingValues[id] || '';
              if (value === prevValue) return;
              if (value) { customSettingValues[id] = value; } else { delete customSettingValues[id]; }
              setViewerSettings($('<input>').attr('id', id).val(value));
              var setting = settings.customSettings[id];
              if (setting && setting.onChange) setting.onChange(value);
            });
          }, 600);
        });
      } catch(ex) {}
    });

    // Fixed default spot (top-left, nudged down/left) for every warning popup — position no
    // longer varies per call site.
    var WARNING_DEFAULT_LEFT = 6;
    var WARNING_DEFAULT_TOP = 18;

    function createWarningMessage(title, target_id, text, visible, width) {
      visible = (visible !== false); width = width || 200;
      var message = wyswygEl.querySelector('#wyswyg-message');
      if (!message) {
        message = document.createElement('div');
        message.classList.add('wyswyg-message');
        message.id = 'wyswyg-message';
        var warnIcon = document.createElement('span');
        warnIcon.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="red"><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>';
        message.appendChild(warnIcon);
        var closeBtn = document.createElement('button');
        closeBtn.classList.add('wyswyg-warning-close-btn');
        closeBtn.innerText = '✕';
        message.appendChild(closeBtn);
        var mTitle = document.createElement('h4'); mTitle.classList.add('wyswyg-message-title'); message.appendChild(mTitle);
        var mText = document.createElement('div'); mText.id = 'wyswyg-message-text'; message.appendChild(mText);
        (wyswygEl.querySelector('#Intf_main_container') || wyswygEl.querySelector('#anim_container_intf') || wyswygEl).appendChild(message);
        message.addEventListener('click', function() {
          message.style.display = 'none';
          wyswygEl.querySelectorAll('.wyswyg-warning-setting').forEach(function(el) { el.classList.remove('wyswyg-warning-setting'); });
        });
      }
      message.querySelector('.wyswyg-message-title').innerText = title;
      var mTextEl = message.querySelector('#wyswyg-message-text');
      if (text) { mTextEl.classList.add('wyswyg-message-text'); } else { mTextEl.classList.remove('wyswyg-message-text'); }
      mTextEl.innerHTML = text || '';
      message.style.display = visible ? 'block' : 'none';
      message.style.right = '';
      message.style.top = WARNING_DEFAULT_TOP + 'px'; message.style.left = WARNING_DEFAULT_LEFT + 'px'; message.style.width = width + 'px';
      if (target_id) {
        target_id.split(',').filter(Boolean).forEach(function(sel) {
          document.querySelectorAll(sel).forEach(function(el) { el.classList.add('wyswyg-warning-setting'); });
        });
      }
    }

    // icon-input-question/send/send-hover custom icons use the generic insertGraIcon/removeGraIcon
    // helper, which keeps the placeholder element in the DOM and toggles `hidden-intf` rather than
    // adding/removing it — the hover icon is additionally kept `display:none` inline until actually
    // hovered, so `.is(':visible')` would never detect it; checking `hidden-intf` is the reliable
    // signal. Guard on element existence first: these ids don't exist at all on admin-assistant.
    function isGraCustomIconActive(elId) {
      var el = document.getElementById(elId);
      return !!el && !el.classList.contains('hidden-intf');
    }

    function checkInputWarning(id) {
      if ((id === 'project_source_button_border_color' || id === 'project_source_button_text_color' || id === 'project_source_button_color'
          || id === 'Intf_SourceLinkButtonColorHover' || id === 'Intf_SourceLinkButtonTextColorHover' || id === 'Intf_SourceLinkButtonBorderColorHover'
          || id === 'project_source_button_border_radius' || id === 'project_source_button_margin_top_bottom' || id === 'project_source_button_margin_right_left')
          && $("input[name='project[source_button]']:checked").val() === 'false')
        createWarningMessage('The source buttons are disabled!', '#source-button-disabled-example-intf a');
      if (id === 'project_typing_dots_color' && ['above-input-box', 'above-input-text-only', 'instead-message-text-only'].includes($("#project_typing_label_position").val()))
        createWarningMessage('Typing dots are not enabled!', '#typing-label-text-intf', 'Typing dots are available for the following <strong>Typing Label Position</strong> settings: <br>instead-message<br>instead-message-dots-only<br>above-input-dots-only<br>above-input-text-and-dots<br>instead-message-text-and-dots<br>above-input-box-with-dots', true, 250);
      if ((id === 'project_typing_dots_size' || id === 'project_typing_dots_margin_between' || id === 'project_typing_dots_jump_height')
          && !['instead-message', 'above-input-box-with-dots', 'instead-message-dots-only', 'instead-message-text-and-dots', 'above-input-dots-only', 'above-input-text-and-dots'].includes($("#project_typing_label_position").val()))
        createWarningMessage('Typing dots are not enabled!', '#typing-label-text-intf', 'This setting is available for the following <strong>Typing Label Position</strong> settings: <br>instead-message<br>above-input-box-with-dots<br>instead-message-dots-only<br>instead-message-text-and-dots<br>above-input-dots-only<br>above-input-text-and-dots', true, 250);
      if (id === 'project_typing_text_color' && ['instead-message', 'instead-message-dots-only', 'above-input-dots-only'].includes($("#project_typing_label_position").val()))
        createWarningMessage('The Typing Text label is not available!', '#typing-label-dots-intf', 'The Typing Text label is displayed for: <br>above-input-box<br>above-input-text-only<br>instead-message-text-only<br>above-input-text-and-dots<br>instead-message-text-and-dots<br>above-input-box-with-dots', true, 250);
      if ((id === 'project_icon_answer_text_color' || id === 'project_icon_answer_background_color_to' || id === 'project_icon_answer_background_color_from')
          && ($('#project_answer_icon').val() !== '' || $('#answer-icon-custom').is(':visible') || document.getElementById('icon-answer-custom-gra')))
        createWarningMessage('A custom answer icon is uploaded!', '#answer-icon-custom, #icon-answer-custom-gra, #icon-first-message-custom-gra', 'These color settings cannot be applied because a custom answer icon has been uploaded. Remove the custom icon to use these color settings.', true, 230);
      if ((id === 'project_icon_question_text_color' || id === 'project_icon_question_background_color_to' || id === 'project_icon_question_background_color_from')
          && ($('#project_question_icon').val() !== '' || document.getElementById('icon-question-custom-gra')))
        createWarningMessage('A custom question icon is uploaded!', '#icon-question-custom-gra', 'These color settings cannot be applied because a custom question icon has been uploaded. Remove the custom icon to use these color settings.', true, 230);
      if (id === 'project_icon_input_question_color'
          && ($('#project_icon_input_question').val() !== '' || isGraCustomIconActive('icon-input-question-custom-gra')))
        createWarningMessage('A custom input question icon is uploaded!', '#icon-input-question-custom-gra', 'This color setting cannot be applied because a custom input question icon has been uploaded. Remove the custom icon to use this color setting.', true, 230);
      if ((id === 'project_icon_send_color' || id === 'project_icon_send_background_color')
          && ($('#project_icon_send').val() !== '' || isGraCustomIconActive('icon-send-custom-gra')))
        createWarningMessage('A custom send icon is uploaded!', '#icon-send-custom-gra', 'These color settings cannot be applied because a custom send icon has been uploaded. Remove the custom icon to use these color settings.', true, 230);
      if ((id === 'project_icon_send_hover_color' || id === 'project_icon_send_hover_background_color')
          && ($('#project_icon_send_hover').val() !== '' || isGraCustomIconActive('icon-send-hover-custom-gra')))
        createWarningMessage('A custom send [hover] icon is uploaded!', '#icon-send-hover-custom-gra', 'These color settings cannot be applied because a custom send [hover] icon has been uploaded. Remove the custom icon to use these color settings.', true, 230);
      if ((id === 'project_icon_thumb_border_color' || id === 'project_icon_thumb_background_color') && $("input[name='project[feedback]']:checked").val() === 'false')
        createWarningMessage('Feedback is disabled!', '#footer-buttons-intf');
      if ((id === 'project_icon_copy_button_color' || id === 'Intf_CopyButtonTextColor' || id === 'Intf_CopyButtonHoverTextColor'
          || id === 'Intf_CopyButtonIconColor' || id === 'Intf_CopiedButtonTextColor' || id === 'Intf_CopiedButtonIconColor')
          && $("input[name='project[copy]']:checked").val() === 'false')
        createWarningMessage('Copy answer is disabled!', '#footer-buttons-intf');
      if (id === 'project_icon_resize_color' && $("input[name='project[resize]']:checked").val() === 'false')
        createWarningMessage('Maximize is disabled!', '#icon-wrapper-intf');
      if ((id === 'project_icon_dark_mode_color' || id === 'project_icon_light_mode_color') && $("input[name='project[theme_switch]']:checked").val() === 'false')
        createWarningMessage('Theme switcher is disabled!', '#icon-wrapper-intf');
      if (id === 'project_icon_font_size_change_color' && $("input[name='project[font_size_switch]']:checked").val() === 'false')
        createWarningMessage('Font size switcher is disabled!', '#icon-wrapper-intf');
      if (id === 'Intf_IconSessionRestart') {
        var sessionRestartOn = customSettingValues['Intf_sessionRestartButton'] !== undefined
          ? customSettingValues['Intf_sessionRestartButton'] === 'true'
          : !!settings.customSettings['Intf_sessionRestartButton'].default;
        if (!sessionRestartOn)
          createWarningMessage('Session restart button is disabled!', '#icon-wrapper-intf', 'Enable the <strong>Session Restart Button</strong> custom setting to see this color applied.', true, 230);
      }
      if (id === 'project_icon_hello_color' && ($('#project_first_message_text').val() || '').trim())
        createWarningMessage('Hello block is hidden!', '#hello-block-intf', 'The Hello block is only visible when the <strong>First message text</strong> field is empty.', true, 230);
      if (id === 'project_hello_text_color' && ($('#project_first_message_text').val() || '').trim())
        createWarningMessage('Hello block is hidden!', '#hello-block-intf', 'The Hello block is only visible when the <strong>First message text</strong> field is empty.', true, 230);
      if (id === 'project_hello_text_color' && !($('#project_welcome_message_title').val() || '').trim() && !($('#project_welcome_message_subtitle').val() || '').trim())
        createWarningMessage('Welcome message is empty!', '#hello-block-intf', 'Fill in the <strong>Welcome message title</strong> or <strong>Welcome message subtitle</strong> field to see this setting.', true, 230);
      if (id === 'project_chat_question_title_color' && !($('#project_question_message_title').val() || '').trim())
        createWarningMessage('Question title is empty!', '.question-title-person-intf', 'Fill in the <strong>Question message title</strong> field to see this setting.', true, 230);
      if (id === 'project_chat_answer_title_color' && !($('#project_answer_message_title').val() || '').trim())
        createWarningMessage('Answer title is empty!', '.answer-title-person-intf', 'Fill in the <strong>Answer message title</strong> field to see this setting.', true, 230);
      if (id === 'project_question_answer_title_color' && !($('#project_question_message_title').val() || '').trim() && !($('#project_answer_message_title').val() || '').trim())
        createWarningMessage('Title fields are empty!', '.question-title-person-intf,.answer-title-person-intf', 'Fill in the <strong>Question message title</strong> or <strong>Answer message title</strong> field to see this setting.', true, 230);
      if (id === 'project_chat_question_subtitle_color' && !($('#project_question_message_subtitle').val() || '').trim())
        createWarningMessage('Question subtitle is empty!', '.question-title-name-intf', 'Fill in the <strong>Question message subtitle</strong> field to see this setting.', true, 230);
      if (id === 'project_chat_answer_subtitle_color' && !($('#project_answer_message_subtitle').val() || '').trim())
        createWarningMessage('Answer subtitle is empty!', '.answer-title-name-intf', 'Fill in the <strong>Answer message subtitle</strong> field to see this setting.', true, 230);
      if (id === 'project_question_answer_subtitle_color' && !($('#project_question_message_subtitle').val() || '').trim() && !($('#project_answer_message_subtitle').val() || '').trim())
        createWarningMessage('Subtitle fields are empty!', '.question-title-name-intf,.answer-title-name-intf', 'Fill in the <strong>Question message subtitle</strong> or <strong>Answer message subtitle</strong> field to see this setting.', true, 230);
      if ((id === 'project_hint_text_color' || id === 'project_hint_border_color' || id === 'project_hint_background_color'
          || id === 'project_hint_window_width' || id === 'project_hint_font_size') && !($('#project_hint_message').val() || '').trim())
        createWarningMessage('Hint message is empty!', '.message-container-intf', 'Fill in the <strong>Hint message</strong> field to see this setting.', true, 230);
      if (id === 'project_question_placeholder_color' && !($('#project_question_placeholder_text').val() || '').trim())
        createWarningMessage('Question placeholder is empty!', questionInputSel, 'Fill in the <strong>Question placeholder text</strong> field to see this setting.', true, 230);
      if (id === 'project_input_border_color' && settings.template === 'admin-gra' && !(parseInt($('#project_input_border_width').val()) > 0))
        createWarningMessage('Input border width is 0!', questionInputSel, 'Set <strong>Input border width</strong> to a value greater than 0 to see the border color.', true, 230);
      if (id === 'project_background_image_transparency' && !currentBackgroundImageDataUrl)
        createWarningMessage('No background image uploaded!', '.message-container-intf', 'Upload a <strong>Background image</strong> to apply this setting.', true, 230);
      if (id === 'project_background_color' && currentBackgroundImageDataUrl)
        createWarningMessage('A background image is uploaded!', '.message-container-intf', 'This color setting cannot be applied because a background image has been uploaded. Remove the background image to use the background color.', true, 230);
    }

    function setViewerData(item) {
      function initOnce() {
        var darkLightContainer = document.getElementById('id-dark-light-container-intf');
        if (darkLightContainer && !darkLightContainer.dataset.toggleInited) {
          darkLightContainer.dataset.toggleInited = '1';
          darkLightContainer.addEventListener('click', function() { toggleDarkLightMode(); });
        }
        var responseContainer = document.getElementById('response-container-intf');
        var upBtn = document.getElementById('icon-scroll-up-intf');
        var downBtn = document.getElementById('icon-scroll-down-intf');
        if (responseContainer && upBtn && downBtn && !responseContainer.dataset.scrollToggleInited) {
          responseContainer.dataset.scrollToggleInited = '1';
          // Stop propagation so the generic delegated click handler on wyswygEl never runs for
          // this click — it would call showClickInfo(e.target.closest('svg')), which still
          // resolves to the icon that was JUST hidden by scrollToTop/scrollToBottom below (closest()
          // doesn't care about the hidden-intf class), showing settings for an icon the user can no
          // longer see. Call showClickInfo() directly on whichever icon the swap just revealed instead.
          upBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            closeStatePicker();
            scrollToTop();
            showClickInfo(downBtn);
          });
          downBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            closeStatePicker();
            scrollToBottom();
            showClickInfo(upBtn);
          });
          responseContainer.addEventListener('scroll', function() {
            var atTop    = responseContainer.scrollTop <= 0;
            var atBottom = responseContainer.scrollTop + responseContainer.clientHeight >= responseContainer.scrollHeight - 1;
            if (atTop)    { downBtn.classList.remove('hidden-intf'); upBtn.classList.add('hidden-intf'); }
            else if (atBottom) { upBtn.classList.remove('hidden-intf'); downBtn.classList.add('hidden-intf'); }
          });
        }
      }

      initOnce();

      item.on('input', function() {
        $('.wyswyg-message').hide();
        $('.wyswyg-warning-setting').removeClass('wyswyg-warning-setting');
        $(questionInputSel).val('');
        setViewerSettings(item);
      });
      setViewerSettings(item, true);

      $(window).on('load', function() { setTimeout(function() { scrollViewerTo(265); }, 1000); });
      $(document).on('click', '#ui-id-3', function() { setTimeout(function() { scrollViewerTo(265); }, 1000); });
    }

    $('.minicolors-input').each(function() { setViewerData($(this)); });

    // The copy button's Hover/Copied text colors fall back to this base color (see
    // applyCopyStateColor) when no state-specific custom color is set — keep that fallback live
    // if the base color changes while the custom one is empty. Also run once now: unlike the
    // other viewerIdStyles-mapped settings, Intf_CopyButtonHoverTextColor/Intf_CopiedButtonTextColor
    // have no real, always-present form field to auto-wire on load, so without this the :hover
    // rule (and its underline) would never exist at all until the custom panel is opened once.
    function refreshCopyStateFallbacks() {
      if (!customSettingValues['Intf_CopyButtonHoverTextColor']) applyCopyStateColor('style-hover-color', null);
      if (!customSettingValues['Intf_CopiedButtonTextColor']) applyCopyStateColor('style-copied-color', null);
    }
    $('#project_icon_copy_button_color').on('input', refreshCopyStateFallbacks);
    refreshCopyStateFallbacks();

    // Same reasoning as refreshCopyStateFallbacks() above: the source-button hover colors have no
    // real, always-present form field either, so without an explicit call here the :hover rule
    // would never exist until the custom panel is opened once. sourceButtonHoverStyleValues is
    // already seeded with the real widget's defaults, so this just injects that starting rule.
    applySourceButtonHoverStyle('background-color', customSettingValues['Intf_SourceLinkButtonColorHover']);
    applySourceButtonHoverStyle('color', customSettingValues['Intf_SourceLinkButtonTextColorHover']);
    applySourceButtonHoverStyle('border-color', customSettingValues['Intf_SourceLinkButtonBorderColorHover']);

    // Apply initial text viewer field values
    settings.textViewerFields.forEach(function(prop) {
      var val = $('#project_' + prop).val();
      if (val) $('[data-text-viewer="' + prop + '"]').text(val);
    });
    $('#project_question_placeholder_text').trigger('input');

    if (settings.template === 'admin-gra') {
      function updateGraFirstMessageTitle() {
        var titleBlock = wyswygEl.querySelector('#first-message-title-gra');
        if (!titleBlock) return;
        var subtitle = ($('#project_first_message_subtitle').val() || '').trim();
        var title = ($('#project_first_message_title').val() || '').trim();
        titleBlock.style.display = (subtitle || title) ? '' : 'none';
        titleBlock.querySelector('.answer-title-person-intf_gra').textContent = title;
        titleBlock.querySelector('.answer-title-name-intf_gra').textContent = subtitle;
      }

      function updateGraFirstMessage() {
        var wrapper = wyswygEl.querySelector('#first-message-wrapper-gra');
        if (!wrapper) return;
        var text = ($('#project_first_message_text').val() || '').trim();
        if (text) {
          wrapper.querySelector('.answer-intf_gra p').textContent = text;
          wrapper.style.display = '';
        } else {
          wrapper.style.display = 'none';
        }
        updateGraFirstMessageTitle();
        updateTailPositions();
      }

      $('#project_first_message_text').on('input.gra', updateGraFirstMessage).trigger('input.gra');
      $('#project_first_message_title').on('input.gra', updateGraFirstMessageTitle).trigger('input.gra');
      $('#project_first_message_subtitle').on('input.gra', updateGraFirstMessageTitle).trigger('input.gra');

      $('#project_chat_block_scrollbar_width').on('change.gra', function() {
        var rc = wyswygEl.querySelector('#response-container-intf');
        if (rc) rc.style.scrollbarWidth = $(this).val() === 'thin' ? 'thin' : 'auto';
      }).trigger('change.gra');

      $('#project_icon_tails_answer_question').on('change.gra', updateTailsMasterVisibility);

      $('#project_answer_question_block_border_radius, #project_answer_block_border_radius_bottom_right, '
        + '#project_answer_block_border_radius_bottom_left, #project_question_block_border_radius_bottom_right, '
        + '#project_question_block_border_radius_bottom_left').on('input.gra', updateTailPositions);

      $('#project_answer_background_color, #project_question_background_color').on('input.gra', updateTailColors);

      updateTailsMasterVisibility();
      updateTailPositions();
      updateTailColors();
    }

    return this;
  };
})(jQuery);
